export const listSVGIcon02 = {
  favorite: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.6602 3.99065C17.0202 2.19065 13.7602 3.03065 12.0002 5.09065C10.2402 3.03065 6.98021 2.18065 4.34021 3.99065C2.94021 4.95065 2.06021 6.57065 2.00021 8.28065C1.86021 12.1607 5.30021 15.2707 10.5502 20.0407L10.6502 20.1307C11.4102 20.8207 12.5802 20.8207 13.3402 20.1207L13.4502 20.0207C18.7002 15.2607 22.1302 12.1507 22.0002 8.27065C21.9402 6.57065 21.0602 4.95065 19.6602 3.99065ZM12.1002 18.5507L12.0002 18.6507L11.9002 18.5507C7.14021 14.2407 4.00021 11.3907 4.00021 8.50065C4.00021 6.50065 5.50021 5.00065 7.50021 5.00065C9.04021 5.00065 10.5402 5.99065 11.0702 7.36065H12.9402C13.4602 5.99065 14.9602 5.00065 16.5002 5.00065C18.5002 5.00065 20.0002 6.50065 20.0002 8.50065C20.0002 11.3907 16.8602 14.2407 12.1002 18.5507Z"
        fill="#838383"
      />
    </svg>
  ),
  truck: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.7138 12.7116L18.6672 9.67489C18.5177 9.52572 18.303 9.4404 18.0781 9.4404H15.2805V7.72687C15.2805 6.91794 14.6526 6.25977 13.8808 6.25977H4.53006C3.7583 6.25977 3.13037 6.91794 3.13037 7.72687V15.7367C3.13037 16.2026 3.50264 16.5815 3.95984 16.5815H6.13577C6.30411 17.2425 6.97122 17.738 7.76749 17.738C8.56377 17.738 9.23057 17.2425 9.39921 16.5815H14.6825H15.2805H17.5357C17.704 17.2425 18.3712 17.738 19.1674 17.738C19.9637 17.738 20.6308 17.2425 20.7991 16.5815H21.1248C21.5592 16.5815 21.913 16.268 21.913 15.883V13.1756C21.913 13.005 21.8424 12.8402 21.7138 12.7116ZM20.9481 12.7458H17.3138C17.2376 12.7458 17.1754 12.691 17.1754 12.6234V11.182C17.1754 11.1144 17.2376 11.0593 17.3138 11.0593H19.2559L20.9481 12.7458ZM7.76749 17.2081C7.17425 17.2081 6.69164 16.7804 6.69164 16.2548C6.69164 15.7291 7.17425 15.3011 7.76749 15.3011C8.36074 15.3011 8.84335 15.7288 8.84335 16.2548C8.84335 16.7804 8.36074 17.2081 7.76749 17.2081ZM9.42373 16.0515C9.3113 15.3298 8.61251 14.7715 7.76749 14.7715C6.92248 14.7715 6.22368 15.3298 6.11125 16.0515H3.95984C3.8504 16.0515 3.7284 15.9225 3.7284 15.7367V7.72687C3.7284 7.21019 4.08812 6.78969 4.53006 6.78969H13.8808C14.3231 6.78969 14.6825 7.21019 14.6825 7.72687V9.4404V13.5733H6.39262C6.22757 13.5733 6.09361 13.6918 6.09361 13.8383C6.09361 13.9848 6.22757 14.1032 6.39262 14.1032H14.6825V16.0515H9.42373ZM19.1671 17.2081C18.5742 17.2081 18.0913 16.7804 18.0913 16.2548C18.0913 15.7291 18.5739 15.3011 19.1671 15.3011C19.7604 15.3011 20.2433 15.7288 20.2433 16.2548C20.2433 16.7804 19.7607 17.2081 19.1671 17.2081ZM21.1248 16.0515H20.8237C20.7112 15.3298 20.0121 14.7715 19.1671 14.7715C18.3221 14.7715 17.6233 15.3298 17.5109 16.0515H15.2802V9.97033H18.0778C18.1322 9.97033 18.1837 9.99099 18.2201 10.027L18.7243 10.5294H17.3138C16.9078 10.5294 16.5774 10.8222 16.5774 11.182V12.6234C16.5774 12.983 16.9075 13.2758 17.3138 13.2758H21.3149V15.883C21.3149 15.976 21.2297 16.0515 21.1248 16.0515Z"
        fill="black"
        stroke="black"
        strokeWidth="0.5"
      />
    </svg>
  ),
  share: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z"
        fill="#838383"
      />
    </svg>
  ),
  'key-next': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.29006 15.8805L13.1701 12.0005L9.29006 8.12047C8.90006 7.73047 8.90006 7.10047 9.29006 6.71047C9.68006 6.32047 10.3101 6.32047 10.7001 6.71047L15.2901 11.3005C15.6801 11.6905 15.6801 12.3205 15.2901 12.7105L10.7001 17.3005C10.3101 17.6905 9.68006 17.6905 9.29006 17.3005C8.91006 16.9105 8.90006 16.2705 9.29006 15.8805Z"
        fill="#838383"
      />
    </svg>
  ),
  'key-previous': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7099 15.8805L10.8299 12.0005L14.7099 8.12047C15.0999 7.73047 15.0999 7.10047 14.7099 6.71047C14.3199 6.32047 13.6899 6.32047 13.2999 6.71047L8.70994 11.3005C8.31994 11.6905 8.31994 12.3205 8.70994 12.7105L13.2999 17.3005C13.6899 17.6905 14.3199 17.6905 14.7099 17.3005C15.0899 16.9105 15.0999 16.2705 14.7099 15.8805Z"
        fill="#838383"
      />
    </svg>
  ),
  'media-solid': (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_28_4323)">
        <path
          d="M0.937857 0H8.43786C8.7484 0 9.04137 0.158203 9.21715 0.416016L13.9691 7.54102C11.0687 7.78125 8.46129 9.04102 6.49254 10.957L0.15856 1.45898C-0.0347996 1.17188 -0.0523777 0.802734 0.111685 0.498047C0.275747 0.193359 0.592153 0 0.937857 0ZM29.8422 1.45898L23.5082 10.9629C21.5453 9.04688 18.932 7.78711 16.0316 7.54688L20.7836 0.416016C20.9593 0.152344 21.2523 0 21.5629 0H29.0629C29.4086 0 29.725 0.1875 29.889 0.498047C30.0531 0.808594 30.0355 1.17188 29.8422 1.45898ZM25.3129 19.6875C25.3129 25.3828 20.6957 30 15.0004 30C9.30504 30 4.68786 25.3828 4.68786 19.6875C4.68786 13.9922 9.30504 9.375 15.0004 9.375C20.6957 9.375 25.3129 13.9922 25.3129 19.6875ZM15.4925 14.127C15.2933 13.7168 14.7132 13.7168 14.5082 14.127L13.1957 16.7871C13.1136 16.9512 12.9613 17.0625 12.7855 17.0859L9.84411 17.5137C9.39293 17.5781 9.21715 18.1289 9.53942 18.4512L11.6664 20.5254C11.7953 20.6543 11.8539 20.8301 11.8246 21.0117L11.3207 23.9355C11.2445 24.3809 11.7132 24.7266 12.1175 24.5156L14.7425 23.1328C14.9007 23.0508 15.0941 23.0508 15.2523 23.1328L17.8773 24.5156C18.2816 24.7266 18.7504 24.3867 18.6742 23.9355L18.1703 21.0117C18.141 20.8359 18.1996 20.6543 18.3285 20.5254L20.4554 18.4512C20.7836 18.1348 20.6019 17.584 20.1507 17.5137L17.2152 17.0859C17.0394 17.0625 16.8812 16.9453 16.805 16.7871L15.4925 14.127Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_28_4323">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  handshake: (
    <svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_28_4342)">
        <path
          d="M18.9492 4.99219L13.2773 9.58594C12.334 10.3477 12.1523 11.7188 12.8672 12.6973C13.623 13.7402 15.0938 13.9453 16.1074 13.1543L21.9258 8.63086C22.3359 8.31445 22.9219 8.38477 23.2441 8.79492C23.5664 9.20508 23.4902 9.79102 23.0801 10.1133L21.8555 11.0625L30 18.5625V7.5H29.959L29.7305 7.35352L25.4766 4.62891C24.5801 4.05469 23.5312 3.75 22.4648 3.75C21.1875 3.75 19.9453 4.18945 18.9492 4.99219ZM20.2852 12.2813L17.2559 14.6367C15.4102 16.0781 12.7324 15.7031 11.3496 13.8047C10.0488 12.0176 10.377 9.52148 12.0938 8.13281L16.9688 4.18945C16.2891 3.90234 15.5566 3.75586 14.8125 3.75586C13.7109 3.75 12.6387 4.07813 11.7188 4.6875L7.5 7.5V20.625H9.15234L14.5078 25.5117C15.6562 26.5605 17.4316 26.4785 18.4805 25.3301C18.8027 24.9727 19.0195 24.5566 19.1309 24.123L20.127 25.0371C21.2695 26.0859 23.0508 26.0098 24.0996 24.8672C24.3633 24.5801 24.5566 24.2461 24.6797 23.9004C25.8164 24.6621 27.3633 24.5039 28.3184 23.4609C29.3672 22.3184 29.291 20.5371 28.1484 19.4883L20.2852 12.2813ZM5.625 7.5H0V20.625C0 21.6621 0.837891 22.5 1.875 22.5H3.75C4.78711 22.5 5.625 21.6621 5.625 20.625V7.5ZM2.8125 20.625C2.29688 20.625 1.875 20.2031 1.875 19.6875C1.875 19.1719 2.29688 18.75 2.8125 18.75C3.32812 18.75 3.75 19.1719 3.75 19.6875C3.75 20.2031 3.32812 20.625 2.8125 20.625ZM31.875 7.5V20.625C31.875 21.6621 32.7129 22.5 33.75 22.5H35.625C36.6621 22.5 37.5 21.6621 37.5 20.625V7.5H31.875ZM35.625 19.6875C35.625 20.2031 35.2031 20.625 34.6875 20.625C34.1719 20.625 33.75 20.2031 33.75 19.6875C33.75 19.1719 34.1719 18.75 34.6875 18.75C35.2031 18.75 35.625 19.1719 35.625 19.6875Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_28_4342">
          <rect width="37.5" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'file-sign': (
    <svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_28_4295)">
        <path
          d="M21.5 25.8011V26.25C21.5 28.0529 20.0691 29.5 18.3333 29.5H3.66667C1.93095 29.5 0.5 28.0529 0.5 26.25V3.75C0.5 1.94713 1.93095 0.5 3.66667 0.5H12.3333V7.5C12.3333 8.8026 13.3659 9.875 14.6667 9.875H21.5V11.7259L16.2112 17.1348C15.6785 17.6797 15.3019 18.3574 15.1203 19.1069L14.2611 22.6276L14.2606 22.6298C14.2225 22.789 14.1962 22.9491 14.1815 23.109C13.6396 22.4196 12.8125 22 11.9167 22C11.4771 22 11.0538 22.0999 10.6721 22.2848L10.1964 20.6657L10.1963 20.6655C9.94136 19.7988 9.15626 19.1875 8.25 19.1875C7.34376 19.1875 6.55867 19.7988 6.30368 20.6655C6.30367 20.6655 6.30367 20.6655 6.30366 20.6655L5.45002 23.5659L5.44916 23.5688C5.39499 23.7572 5.23267 23.875 5.05312 23.875H4.58333C3.79249 23.875 3.16667 24.5314 3.16667 25.3125C3.16667 26.0936 3.79249 26.75 4.58333 26.75H5.05312C6.49583 26.75 7.75803 25.7833 8.16826 24.387L8.16848 24.3863L8.25369 24.0946L8.73812 25.7276C8.89899 26.2893 9.39269 26.6935 9.96759 26.7478C10.5521 26.803 11.1089 26.482 11.3642 25.952C11.3644 25.9517 11.3645 25.9513 11.3647 25.951L11.8679 24.9159L11.868 24.9159L11.8725 24.9063C11.8764 24.8977 11.8828 24.8901 11.8923 24.8841C11.9022 24.8778 11.913 24.875 11.9224 24.875C11.9361 24.875 11.9605 24.8826 11.9772 24.9165C11.9773 24.9167 11.9773 24.9168 11.9774 24.9169L12.481 25.953L12.4815 25.954C12.7186 26.439 13.2062 26.75 13.75 26.75H17.4167C17.4952 26.75 17.5696 26.7417 17.6172 26.7363C17.8185 26.7218 18.0144 26.6876 18.203 26.6426L18.2031 26.6427L18.2106 26.6407L21.5 25.8011ZM18.2268 19.1582L18.2269 19.158L25.2715 11.9478L28.6399 15.3927L21.5795 22.6192C21.5794 22.6192 21.5794 22.6193 21.5793 22.6193C21.4094 22.7931 21.1927 22.9168 20.9597 22.9765C20.9596 22.9765 20.9595 22.9765 20.9595 22.9765L17.5164 23.8554L17.5141 23.856C17.3767 23.8917 17.2336 23.8534 17.1268 23.7442C17.0189 23.6339 16.9755 23.478 17.0138 23.3239L17.0144 23.3217L17.8738 19.8002L17.8742 19.7984C17.9334 19.5521 18.0551 19.3337 18.2268 19.1582ZM20.8118 7H15.1667V1.22655L20.8118 7ZM28.6126 8.53625C28.6128 8.53608 28.613 8.5359 28.6131 8.53574C29.3174 7.82061 30.4446 7.82244 31.1415 8.53511L31.9653 9.37771C31.9656 9.37796 31.9658 9.37821 31.9661 9.37846C32.6712 10.105 32.6694 11.2773 31.9665 11.9961L30.6396 13.3532L27.2712 9.9082L28.6126 8.53625Z"
          fill="#00C590"
          stroke="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_28_4295">
          <rect width="33" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'back-arrow': (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M41.55 7.4749C40.325 6.2499 38.35 6.2499 37.125 7.4749L16.35 28.2499C15.375 29.2249 15.375 30.7999 16.35 31.7749L37.125 52.5499C38.35 53.7749 40.325 53.7749 41.55 52.5499C42.775 51.3249 42.775 49.3499 41.55 48.1249L23.45 29.9999L41.575 11.8749C42.775 10.6749 42.775 8.6749 41.55 7.4749Z"
        fill="white"
      />
    </svg>
  ),

  'next-arrow': (
    <svg width="60" height="68" viewBox="0 0 60 68" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_225_8601)">
        <path
          d="M18.45 11.4749C19.675 10.2499 21.65 10.2499 22.875 11.4749L43.65 32.2499C44.625 33.2249 44.625 34.7999 43.65 35.7749L22.875 56.5499C21.65 57.7749 19.675 57.7749 18.45 56.5499C17.225 55.3249 17.225 53.3499 18.45 52.1249L36.55 33.9999L18.425 15.8749C17.225 14.6749 17.225 12.6749 18.45 11.4749Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_225_8601"
          x="-10"
          y="-6"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_225_8601" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_225_8601"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  shopping: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
        fill="#154398"
      />
    </svg>
  ),
  'access-time': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99325 1.33301C4.31325 1.33301 1.33325 4.31967 1.33325 7.99967C1.33325 11.6797 4.31325 14.6663 7.99325 14.6663C11.6799 14.6663 14.6666 11.6797 14.6666 7.99967C14.6666 4.31967 11.6799 1.33301 7.99325 1.33301ZM7.99992 13.333C5.05325 13.333 2.66659 10.9463 2.66659 7.99967C2.66659 5.05301 5.05325 2.66634 7.99992 2.66634C10.9466 2.66634 13.3333 5.05301 13.3333 7.99967C13.3333 10.9463 10.9466 13.333 7.99992 13.333Z"
        fill="#838383"
      />
      <path
        d="M8.33325 4.66699H7.33325V8.66699L10.8333 10.767L11.3333 9.94699L8.33325 8.16699V4.66699Z"
        fill="#838383"
      />
    </svg>
  ),
  author: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.37333 6.01333L9.98667 6.62667L3.94667 12.6667H3.33333V12.0533L9.37333 6.01333ZM11.7733 2C11.6067 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2ZM9.37333 4.12667L2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667Z"
        fill="#838383"
      />
    </svg>
  ),
  'arrow-right-orange': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.74167 13.2333L10.975 9.99998L7.74167 6.76665C7.41667 6.44165 7.41667 5.91665 7.74167 5.59165C8.06667 5.26665 8.59167 5.26665 8.91667 5.59165L12.7417 9.41665C13.0667 9.74165 13.0667 10.2667 12.7417 10.5917L8.91667 14.4166C8.59167 14.7416 8.06667 14.7416 7.74167 14.4166C7.42501 14.0916 7.41667 13.5583 7.74167 13.2333Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'yellow-checked': (
    <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.29188 5.72323C2.44867 5.00974 1.18672 5.1149 0.473227 5.95812C-0.240261 6.80133 -0.135098 8.06328 0.708115 8.77677L3.29188 5.72323ZM8.5 12.75L7.20812 14.2768C8.00217 14.9487 9.1787 14.8997 9.91421 14.1642L8.5 12.75ZM20.4142 3.66421C21.1953 2.88317 21.1953 1.61683 20.4142 0.835786C19.6332 0.0547378 18.3668 0.0547378 17.5858 0.835786L20.4142 3.66421ZM0.708115 8.77677L7.20812 14.2768L9.79188 11.2232L3.29188 5.72323L0.708115 8.77677ZM9.91421 14.1642L20.4142 3.66421L17.5858 0.835786L7.08579 11.3358L9.91421 14.1642Z"
        fill="#FFF501"
      />
    </svg>
  ),
  'phone-animation': (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2_21117)">
        <path
          d="M27.9796 55.9592C43.4323 55.9592 55.9592 43.4323 55.9592 27.9796C55.9592 12.5269 43.4323 0 27.9796 0C12.5269 0 0 12.5269 0 27.9796C0 43.4323 12.5269 55.9592 27.9796 55.9592Z"
          fill="#1552C1"
        />
        <path
          d="M21.3722 15.5806C22.0247 15.8253 22.5958 16.274 22.922 16.8858C23.8601 18.2317 24.7167 19.6185 25.4508 21.0868C25.614 21.4131 25.7363 21.7801 25.8587 22.1472C26.0218 22.5959 25.9403 23.0853 25.614 23.4116C25.2061 23.8603 24.7167 24.2681 24.3088 24.676C23.8601 25.0839 23.7786 25.1246 24.0233 25.7364C25.2061 28.7139 27.6125 31.0387 30.6715 32.1399C30.8346 32.2215 31.0794 32.1807 31.1609 32.0176C31.528 31.5689 31.9359 31.1203 32.3438 30.6716C32.7924 30.1006 33.5674 29.9375 34.2199 30.2638C35.158 30.7124 36.0553 31.1611 36.9526 31.6505C37.8499 32.1807 38.7065 32.7925 39.6038 33.3635C39.7669 33.4451 39.8893 33.5675 40.0116 33.6898C40.5826 34.3424 40.7458 34.9542 40.1748 35.6884C39.7669 36.2186 39.3183 36.708 38.8696 37.1567C37.7684 38.2171 36.5856 39.1552 35.3212 39.971C34.6686 40.3788 34.0568 40.5012 33.4042 40.3788C31.2833 39.971 29.244 39.1552 27.4086 37.9724C23.2891 35.4437 19.9038 31.936 17.4974 27.735C16.6409 26.2259 16.0291 24.5944 15.662 22.8814L15.5397 22.188V21.617C15.6212 21.4539 15.7028 21.2907 15.7844 21.1276C16.5593 19.7816 17.4974 18.558 18.5579 17.416C19.2105 16.641 19.9854 15.9884 20.8827 15.5398H21.3722V15.5806ZM21.1274 17.2936C21.0459 17.3344 21.0051 17.3752 20.9643 17.416C19.6183 18.6396 18.4355 20.0263 17.4566 21.5354C17.2935 21.7801 17.2119 22.1064 17.2935 22.3919C17.5382 23.7379 17.9869 25.0431 18.6395 26.2667C20.9235 30.6308 24.3904 34.2608 28.6322 36.7896C30.1413 37.7277 31.8543 38.4211 33.6081 38.7474C33.8936 38.8289 34.1791 38.7474 34.4239 38.5842C35.5659 37.8093 36.6671 36.9528 37.646 35.9739C38.0131 35.6068 38.3394 35.2805 38.7065 34.9134C38.5841 34.8319 38.5025 34.7503 38.421 34.7095C36.9526 33.649 35.4027 32.711 33.7713 31.936C33.6081 31.8136 33.4042 31.8544 33.2818 32.0176C32.7924 32.5886 32.2622 33.2004 31.732 33.7714C31.4872 34.0161 31.1202 34.1385 30.7939 34.0161C28.7137 33.4451 26.7968 32.3031 25.2877 30.7532C23.7786 29.2849 22.6773 27.4495 22.0655 25.4509C21.8616 24.9615 22.0247 24.3905 22.4326 24.0642C22.9628 23.6155 23.4931 23.1261 24.0641 22.6367C24.1864 22.5551 24.1864 22.3919 24.1456 22.3104C23.4523 20.8421 22.6365 19.4145 21.6985 18.0686C21.4945 17.7831 21.3314 17.5383 21.1274 17.2936Z"
          fill="white"
        />
        <path
          d="M28.8362 18.5172V16.845C31.365 16.845 33.8121 17.7423 35.7291 19.3737C38.1763 21.4131 39.6038 24.4313 39.6038 27.6126H37.9316C37.9316 22.5959 33.8529 18.558 28.8362 18.5172Z"
          fill="white"
        />
        <path
          d="M28.8362 22.6774V21.0459C32.0583 20.842 35.5252 23.7786 35.4436 27.6533H33.8121C33.8121 24.9206 31.5689 22.7181 28.8362 22.6774Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_21117">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'arrow-up-orange': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.12 14.71L12 10.83L15.88 14.71C16.27 15.1 16.9 15.1 17.29 14.71C17.68 14.32 17.68 13.69 17.29 13.3L12.7 8.70998C12.31 8.31998 11.68 8.31998 11.29 8.70998L6.7 13.3C6.31 13.69 6.31 14.32 6.7 14.71C7.09 15.09 7.73 15.1 8.12 14.71Z"
        fill="#F88C00"
      />
    </svg>
  ),

  link: (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1423 6.59564L9.7783 8.05835C9.52823 8.32651 9.54304 8.75052 9.8112 9.00058C10.0794 9.25065 10.5034 9.23584 10.7534 8.96768L12.1174 7.50497C12.8676 6.70048 14.1396 6.65606 14.9441 7.40626C15.7486 8.15646 15.793 9.42848 15.0428 10.233L13.6789 11.6957C13.4288 11.9638 13.4436 12.3878 13.7118 12.6379C13.9799 12.888 14.4039 12.8732 14.654 12.605L16.018 11.1423C17.2729 9.79661 17.1992 7.686 15.8535 6.43112C14.5078 5.17625 12.3972 5.24995 11.1423 6.59564ZM9.48815 13.2571C9.75631 13.5072 10.1803 13.4924 10.4304 13.2242L13.1584 10.2988C13.4084 10.0306 13.3936 9.6066 13.1255 9.35654C12.8573 9.10647 12.4333 9.12128 12.1832 9.38944L9.45525 12.3149C9.20518 12.583 9.21999 13.007 9.48815 13.2571ZM11.8602 13.646L10.4962 15.1087C9.74599 15.9131 8.47398 15.9576 7.66949 15.2074C6.865 14.4572 6.82058 13.1852 7.57078 12.3807L8.93477 10.918C9.18484 10.6498 9.17003 10.2258 8.90187 9.97572C8.63371 9.72566 8.2097 9.74046 7.95964 10.0086L6.59564 11.4713C5.34076 12.817 5.41447 14.9276 6.76016 16.1825C8.10585 17.4374 10.2165 17.3637 11.4713 16.018L12.8353 14.5553C13.0854 14.2871 13.0706 13.8631 12.8024 13.613C12.5343 13.363 12.1103 13.3778 11.8602 13.646Z"
        fill="black"
      />
    </svg>
  ),
  'download-app': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z"
        fill="black"
      />
    </svg>
  ),
  'small-phone': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.82 10.1733L11.1267 9.98C10.72 9.93334 10.32 10.0733 10.0334 10.36L8.80669 11.5867C6.92003 10.6267 5.37336 9.08667 4.41336 7.19334L5.64669 5.96C5.93336 5.67333 6.07336 5.27334 6.02669 4.86667L5.83336 3.18667C5.75336 2.51333 5.18669 2.00667 4.50669 2.00667L3.35336 2.00667C2.60003 2.00667 1.97336 2.63333 2.02003 3.38667C2.37336 9.08 6.92669 13.6267 12.6134 13.98C13.3667 14.0267 13.9934 13.4 13.9934 12.6467V11.4933C14 10.82 13.4934 10.2533 12.82 10.1733Z"
        fill="black"
      />
    </svg>
  ),
  'home-work': (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M56.6665 8.5H33.9998C32.4415 8.5 31.1665 9.775 31.1665 11.3333V15.895C31.1665 15.895 31.1665 15.895 31.1948 15.9233L45.3615 28.6733C47.1465 30.26 48.1665 32.5833 48.1665 34.9917V36.8333H53.8332V42.5H48.1665V48.1667H53.8332V53.8333H48.1665V59.5H56.6665C58.2248 59.5 59.4998 58.225 59.4998 56.6667V11.3333C59.4998 9.775 58.2248 8.5 56.6665 8.5ZM42.4998 19.8333H36.8332V14.1667H42.4998V19.8333ZM53.8332 31.1667H48.1665V25.5H53.8332V31.1667ZM53.8332 19.8333H48.1665V14.1667H53.8332V19.8333Z"
        fill="white"
      />
      <path
        d="M42.5 56.6667V34.9917C42.5 34.1983 42.16 33.4333 41.565 32.895L27.3983 20.145C26.86 19.635 26.18 19.4083 25.5 19.4083C24.82 19.4083 24.14 19.6633 23.6017 20.145L9.435 32.895C8.84 33.405 8.5 34.17 8.5 34.9917V56.6667C8.5 58.225 9.775 59.5 11.3333 59.5H17C18.5583 59.5 19.8333 58.225 19.8333 56.6667V45.3333H31.1667V56.6667C31.1667 58.225 32.4417 59.5 34 59.5H39.6667C41.225 59.5 42.5 58.225 42.5 56.6667Z"
        fill="white"
      />
    </svg>
  ),
  online: (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.9998 5.66663C18.3598 5.66663 5.6665 18.36 5.6665 34C5.6665 49.64 18.3598 62.3333 33.9998 62.3333C49.6398 62.3333 62.3332 49.64 62.3332 34C62.3332 18.36 49.6398 5.66663 33.9998 5.66663ZM31.1665 56.4683C19.9748 55.08 11.3332 45.56 11.3332 34C11.3332 32.2433 11.5598 30.5716 11.9282 28.9283L25.4998 42.5V45.3333C25.4998 48.45 28.0498 51 31.1665 51V56.4683ZM50.7165 49.2716C49.9798 46.9766 47.8832 45.3333 45.3332 45.3333H42.4998V36.8333C42.4998 35.275 41.2248 34 39.6665 34H22.6665V28.3333H28.3332C29.8915 28.3333 31.1665 27.0583 31.1665 25.5V19.8333H36.8332C39.9498 19.8333 42.4998 17.2833 42.4998 14.1666V13.005C50.8015 16.3766 56.6665 24.5083 56.6665 34C56.6665 39.8933 54.3998 45.2483 50.7165 49.2716Z"
        fill="white"
      />
    </svg>
  ),
  message: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.13882 23.595L5.29076 26.8298C5.1541 26.9447 4.98748 27.0182 4.8105 27.0416C4.63351 27.065 4.45352 27.0374 4.29168 26.9621C4.12984 26.8867 3.99289 26.7667 3.89693 26.6161C3.80098 26.4656 3.75 26.2907 3.75 26.1122V7.50006C3.75 7.25142 3.84877 7.01296 4.02459 6.83715C4.2004 6.66133 4.43886 6.56256 4.6875 6.56256H25.3125C25.5611 6.56256 25.7996 6.66133 25.9754 6.83715C26.1512 7.01296 26.25 7.25142 26.25 7.50006V22.5001C26.25 22.7487 26.1512 22.9872 25.9754 23.163C25.7996 23.3388 25.5611 23.4376 25.3125 23.4376H9.57081L9.13882 23.595Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 13.125H18.75"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 16.875H18.75"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  call: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6812 4.6875C20.2704 5.11493 21.7195 5.95245 22.8832 7.11618C24.047 8.2799 24.8845 9.72899 25.3119 11.3183"
        fill="white"
      />
      <path
        d="M18.6812 4.6875C20.2704 5.11493 21.7195 5.95245 22.8832 7.11618C24.047 8.2799 24.8845 9.72899 25.3119 11.3183"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7114 8.31079C18.665 8.56725 19.5344 9.06976 20.2327 9.768C20.9309 10.4662 21.4334 11.3357 21.6899 12.2893"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8371 14.6268C11.8095 16.6149 13.4211 18.2192 15.4136 19.1826C15.5594 19.2516 15.7207 19.2816 15.8815 19.2694C16.0424 19.2572 16.1973 19.2034 16.3311 19.1131L19.2649 17.1568C19.3947 17.0702 19.544 17.0175 19.6993 17.0032C19.8546 16.9889 20.011 17.0136 20.1543 17.0751L25.643 19.4274C25.8295 19.5066 25.9852 19.6442 26.0866 19.8196C26.188 19.995 26.2297 20.1985 26.2054 20.3996C26.0319 21.7571 25.3695 23.0049 24.3423 23.9092C23.3151 24.8135 21.9935 25.3124 20.625 25.3125C16.3981 25.3125 12.3443 23.6334 9.35549 20.6445C6.36662 17.6556 4.6875 13.6019 4.6875 9.37499C4.68757 8.00645 5.18648 6.68485 6.0908 5.65766C6.99512 4.63047 8.24285 3.96812 9.60035 3.79464C9.80146 3.7703 10.005 3.81198 10.1804 3.9134C10.3558 4.01482 10.4934 4.17048 10.5726 4.35693L12.927 9.85043C12.9879 9.99253 13.0127 10.1475 12.9992 10.3015C12.9857 10.4555 12.9344 10.6038 12.8497 10.7331L10.9001 13.712C10.8114 13.846 10.7589 14.0007 10.7479 14.1611C10.7368 14.3214 10.7676 14.4819 10.8371 14.6268Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  youtube: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6752 8.69886C18.5185 8.10977 18.0549 7.64504 17.4652 7.48577C16.3988 7.19995 12.1203 7.19995 12.1203 7.19995C12.1203 7.19995 7.84391 7.19995 6.77537 7.48577C6.18778 7.64286 5.72423 8.10759 5.56536 8.69886C5.28027 9.76795 5.28027 12 5.28027 12C5.28027 12 5.28027 14.232 5.56536 15.301C5.72206 15.8901 6.1856 16.3549 6.77537 16.5141C7.84391 16.8 12.1203 16.8 12.1203 16.8C12.1203 16.8 16.3988 16.8 17.4652 16.5141C18.0528 16.357 18.5163 15.8923 18.6752 15.301C18.9603 14.232 18.9603 12 18.9603 12C18.9603 12 18.9603 9.76795 18.6752 8.69886Z"
        fill="white"
      />
      <path d="M10.7536 14.0574L14.3074 12L10.7536 9.9425V14.0574Z" fill="#154398" />
    </svg>
  ),
  facebook: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.8079 12.7496L15.1499 10.5789H13.0435V9.16789C13.0435 8.57434 13.3375 7.99435 14.2779 7.99435H15.2491V6.14585C14.6835 6.05574 14.112 6.00699 13.5393 6C11.8056 6 10.6737 7.04127 10.6737 8.92369V10.5789H8.75195V12.7496H10.6737V18H13.0435V12.7496H14.8079Z"
        fill="white"
      />
    </svg>
  ),
  phone: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.23 15.26L16.69 14.97C16.08 14.9 15.48 15.11 15.05 15.54L13.21 17.38C10.38 15.94 8.06004 13.63 6.62004 10.79L8.47004 8.94001C8.90004 8.51001 9.11004 7.91001 9.04004 7.30001L8.75004 4.78001C8.63004 3.77001 7.78004 3.01001 6.76004 3.01001H5.03004C3.90004 3.01001 2.96004 3.95001 3.03004 5.08001C3.56004 13.62 10.39 20.44 18.92 20.97C20.05 21.04 20.99 20.1 20.99 18.97V17.24C21 16.23 20.24 15.38 19.23 15.26Z"
        fill="white"
      />
    </svg>
  ),
  fax: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 8H5C3.34 8 2 9.34 2 11V15C2 16.1 2.9 17 4 17H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V17H20C21.1 17 22 16.1 22 15V11C22 9.34 20.66 8 19 8ZM15 19H9C8.45 19 8 18.55 8 18V14H16V18C16 18.55 15.55 19 15 19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM17 3H7C6.45 3 6 3.45 6 4V6C6 6.55 6.45 7 7 7H17C17.55 7 18 6.55 18 6V4C18 3.45 17.55 3 17 3Z"
        fill="white"
      />
    </svg>
  ),
  email: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L13.06 12.34C12.41 12.75 11.59 12.75 10.94 12.34L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
        fill="white"
      />
    </svg>
  ),
  address: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 13.17 9.42 18.92 11.24 21.11C11.64 21.59 12.37 21.59 12.77 21.11C14.58 18.92 19 13.17 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
        fill="white"
      />
    </svg>
  ),
  'credit-card': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 5.25H3C2.58579 5.25 2.25 5.58579 2.25 6V18C2.25 18.4142 2.58579 18.75 3 18.75H21C21.4142 18.75 21.75 18.4142 21.75 18V6C21.75 5.58579 21.4142 5.25 21 5.25Z"
        stroke="#3776FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 15.75H18.75"
        stroke="#3776FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 15.75H12.75"
        stroke="#3776FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 9.07983H21.75"
        stroke="#3776FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  signup: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.75 4.375H17.5"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.625 2.5V6.25"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.4209 16.8743C3.1893 15.5442 4.29419 14.4398 5.62456 13.672C6.95493 12.9042 8.46393 12.5 9.99997 12.5C11.536 12.5 13.045 12.9043 14.3754 13.6721C15.7057 14.44 16.8106 15.5444 17.579 16.8744"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6915 9.23303C14.3573 10.1354 13.7696 10.9221 12.9991 11.4987C12.2286 12.0752 11.3081 12.417 10.348 12.483C9.38799 12.549 8.42931 12.3364 7.58715 11.8708C6.74499 11.4052 6.05519 10.7063 5.60059 9.85813C5.146 9.00997 4.94596 8.04859 5.0245 7.0895C5.10305 6.1304 5.45683 5.21438 6.04336 4.45148C6.62989 3.68857 7.42421 3.11124 8.3309 2.78883C9.23759 2.46642 10.2181 2.41265 11.1546 2.63397"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  signin: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.34473 13.2812L10.6251 10L7.34473 6.71875"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 10H10.6227"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 3.125H15C15.1658 3.125 15.3247 3.19085 15.4419 3.30806C15.5592 3.42527 15.625 3.58424 15.625 3.75V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H10.625"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  home: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 19V14H14V19C14 19.55 14.45 20 15 20H18C18.55 20 19 19.55 19 19V12H20.7C21.16 12 21.38 11.43 21.03 11.13L12.67 3.6C12.29 3.26 11.71 3.26 11.33 3.6L2.97001 11.13C2.63001 11.43 2.84001 12 3.30001 12H5.00001V19C5.00001 19.55 5.45001 20 6.00001 20H9.00001C9.55001 20 10 19.55 10 19Z"
        fill="#ED1117"
      />
    </svg>
  ),
  contact: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.59241 11.75L2.5 14.25V4.25C2.5 4.08424 2.56585 3.92527 2.68306 3.80806C2.80027 3.69085 2.95924 3.625 3.125 3.625H13.125C13.2908 3.625 13.4497 3.69085 13.5669 3.80806C13.6842 3.92527 13.75 4.08424 13.75 4.25V11.125C13.75 11.2908 13.6842 11.4497 13.5669 11.5669C13.4497 11.6842 13.2908 11.75 13.125 11.75H5.59241Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 11.75V14.875C6.25 15.0408 6.31585 15.1997 6.43306 15.3169C6.55027 15.4342 6.70924 15.5 6.875 15.5H14.4076L17.5 18V8C17.5 7.83424 17.4342 7.67527 17.3169 7.55806C17.1997 7.44085 17.0408 7.375 16.875 7.375H13.75"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sort: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 10H12"
        stroke="#8B939F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 6.25H18.125"
        stroke="#8B939F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 14H5.75"
        stroke="#8B939F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  video: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.875 5.1875H11.875C12.538 5.1875 13.1739 5.45089 13.6428 5.91973C14.1116 6.38857 14.375 7.02446 14.375 7.6875V15.1875C14.375 15.3533 14.3092 15.5122 14.1919 15.6294C14.0747 15.7467 13.9158 15.8125 13.75 15.8125H3.75C3.08696 15.8125 2.45107 15.5491 1.98223 15.0803C1.51339 14.6114 1.25 13.9755 1.25 13.3125V5.8125C1.25 5.64674 1.31585 5.48777 1.43306 5.37056C1.55027 5.25335 1.70924 5.1875 1.875 5.1875V5.1875Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.375 9.25L18.75 6.75V14.25L14.375 11.75"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  camera: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.25 16.75H3.75C3.41848 16.75 3.10054 16.6183 2.86612 16.3839C2.6317 16.1495 2.5 15.8315 2.5 15.5V6.75C2.5 6.41848 2.6317 6.10054 2.86612 5.86612C3.10054 5.6317 3.41848 5.5 3.75 5.5H6.24954L7.49954 3.625H12.4995L13.7495 5.5H16.25C16.5815 5.5 16.8995 5.6317 17.1339 5.86612C17.3683 6.10054 17.5 6.41848 17.5 6.75V15.5C17.5 15.8315 17.3683 16.1495 17.1339 16.3839C16.8995 16.6183 16.5815 16.75 16.25 16.75Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.625C11.5533 13.625 12.8125 12.3658 12.8125 10.8125C12.8125 9.2592 11.5533 8 10 8C8.4467 8 7.1875 9.2592 7.1875 10.8125C7.1875 12.3658 8.4467 13.625 10 13.625Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  rating: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 12V18L10 16L6.5 18V12"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="7.5" r="5.5" stroke="#0D99FF" strokeWidth="2" />
    </svg>
  ),
  voting: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 12V18L10 16L6.5 18V12"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="7.5" r="5.5" stroke="#0D99FF" strokeWidth="2" />
    </svg>
  ),
  'file-icon': (
    <svg width="89" height="89" viewBox="0 0 89 89" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M61.7206 22.3036C59.9655 22.3019 58.2827 21.5995 57.0417 20.3505C55.8007 19.1016 55.1027 17.4081 55.101 15.6419V6.39238H25.5249C24.3901 6.39196 23.2664 6.61648 22.2179 7.05319C21.1694 7.48991 20.2168 8.13025 19.4142 8.93759C18.6117 9.74493 17.9751 10.7035 17.5407 11.7585C17.1064 12.8135 16.8828 13.9442 16.8828 15.0862V67.4948C16.8828 68.6367 17.1064 69.7676 17.5407 70.8226C17.9751 71.8776 18.6117 72.8361 19.4142 73.6434C20.2168 74.4508 21.1694 75.091 22.2179 75.5278C23.2664 75.9645 24.3901 76.1891 25.5249 76.1887H61.0303C62.1648 76.1887 63.2882 75.9638 64.3363 75.5269C65.3844 75.09 66.3367 74.4496 67.1389 73.6423C67.9411 72.835 68.5774 71.8766 69.0116 70.8218C69.4457 69.767 69.6692 68.6365 69.6692 67.4948V22.3036H61.7206Z"
          fill="#0072FF"
        />
      </g>
      <path
        d="M69.6697 22.3036H61.7211C59.966 22.3019 58.2833 21.5995 57.0423 20.3505C55.8012 19.1016 55.1033 17.4081 55.1016 15.6419V6.39238L69.6697 22.3036Z"
        fill="#0072FF"
      />
      <path
        d="M58.8083 33.4431H25.6655C25.3471 33.4431 25.0417 33.3158 24.8165 33.0892C24.5914 32.8626 24.4648 32.5553 24.4648 32.2348C24.4644 32.0759 24.4952 31.9184 24.5553 31.7714C24.6155 31.6245 24.7039 31.4909 24.8154 31.3783C24.9269 31.2658 25.0594 31.1765 25.2053 31.1156C25.3512 31.0547 25.5075 31.0233 25.6655 31.0233H58.8083C59.1275 31.0233 59.4337 31.151 59.6595 31.3782C59.8853 31.6054 60.0121 31.9135 60.0121 32.2348C60.0113 32.5556 59.884 32.8629 59.6584 33.0894C59.4327 33.3159 59.127 33.4431 58.8083 33.4431Z"
        fill="#0072FF"
      />
      <path
        d="M58.8083 40.6702H25.6655C25.3471 40.6702 25.0417 40.5429 24.8165 40.3163C24.5914 40.0897 24.4648 39.7824 24.4648 39.462C24.4644 39.303 24.4952 39.1455 24.5553 38.9986C24.6155 38.8516 24.7039 38.718 24.8154 38.6055C24.9269 38.4929 25.0594 38.4036 25.2053 38.3427C25.3512 38.2818 25.5075 38.2504 25.6655 38.2504H58.8083C59.1275 38.2504 59.4337 38.378 59.6595 38.6052C59.8853 38.8324 60.0121 39.1406 60.0121 39.462C60.0113 39.7827 59.884 40.09 59.6584 40.3165C59.4327 40.543 59.127 40.6702 58.8083 40.6702Z"
        fill="#0072FF"
      />
      <path
        d="M58.8083 47.8973H25.6655C25.5075 47.8973 25.3512 47.8659 25.2053 47.805C25.0594 47.7441 24.9269 47.6548 24.8154 47.5423C24.7039 47.4297 24.6155 47.2961 24.5553 47.1492C24.4952 47.0022 24.4644 46.8447 24.4648 46.6858C24.4648 46.3653 24.5914 46.058 24.8165 45.8314C25.0417 45.6048 25.3471 45.4775 25.6655 45.4775H58.8083C59.127 45.4775 59.4327 45.6047 59.6584 45.8312C59.884 46.0577 60.0113 46.365 60.0121 46.6858C60.0121 47.0071 59.8853 47.3152 59.6595 47.5424C59.4337 47.7697 59.1275 47.8973 58.8083 47.8973Z"
        fill="#0072FF"
      />
      <path
        d="M45.736 55.1244H25.6655C25.5075 55.1244 25.3512 55.0931 25.2053 55.0322C25.0594 54.9712 24.9269 54.8819 24.8154 54.7693C24.7039 54.6568 24.6155 54.5233 24.5553 54.3763C24.4952 54.2293 24.4644 54.0719 24.4648 53.9129C24.4648 53.5925 24.5914 53.2851 24.8165 53.0585C25.0417 52.8319 25.3471 52.7046 25.6655 52.7046H45.736C46.0545 52.7046 46.3599 52.8319 46.5851 53.0585C46.8102 53.2851 46.9367 53.5925 46.9367 53.9129C46.9371 54.0719 46.9064 54.2293 46.8462 54.3763C46.7861 54.5233 46.6977 54.6568 46.5862 54.7693C46.4747 54.8819 46.3421 54.9712 46.1963 55.0322C46.0504 55.0931 45.894 55.1244 45.736 55.1244Z"
        fill="#0072FF"
      />
      <path d="M41.3509 75.3292V77.678H38.9336V75.3292H41.3509Z" fill="white" />
    </svg>
  ),
  'add-primary': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.125 10H16.875"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.125V16.875"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'edit-green': (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.2167 7.51667L12.9833 8.28333L5.43333 15.8333H4.66667V15.0667L12.2167 7.51667ZM15.2167 2.5C15.0083 2.5 14.7917 2.58333 14.6333 2.74167L13.1083 4.26667L16.2333 7.39167L17.7583 5.86667C18.0833 5.54167 18.0833 5.01667 17.7583 4.69167L15.8083 2.74167C15.6417 2.575 15.4333 2.5 15.2167 2.5ZM12.2167 5.15833L3 14.375V17.5H6.125L15.3417 8.28333L12.2167 5.15833Z"
        fill="#00C590"
      />
    </svg>
  ),
  'edit-orange': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.37333 6.01333L9.98667 6.62667L3.94667 12.6667H3.33333V12.0533L9.37333 6.01333ZM11.7733 2C11.6067 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2ZM9.37333 4.12667L2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'arrow-up': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_395_40305)">
        <path d="M12 8L18 14H6L12 8Z" fill="#6A7688" />
      </g>
      <defs>
        <clipPath id="clip0_395_40305">
          <rect width="24" height="24" fill="white" transform="translate(0 24) rotate(-90)" />
        </clipPath>
      </defs>
    </svg>
  ),
  'search-white': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.0625 15.625C12.6869 15.625 15.625 12.6869 15.625 9.0625C15.625 5.43813 12.6869 2.5 9.0625 2.5C5.43813 2.5 2.5 5.43813 2.5 9.0625C2.5 12.6869 5.43813 15.625 9.0625 15.625Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7021 13.7031L17.4991 17.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'check-special': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.25476 15.7452C3.53569 15.0262 4.01262 13.5165 3.64662 12.632C3.26722 11.715 1.875 10.9769 1.875 9.99997C1.875 9.02301 3.26722 8.285 3.64663 7.36803C4.01262 6.48346 3.5357 4.97382 4.25476 4.25476C4.97382 3.53569 6.48346 4.01262 7.36804 3.64662C8.28503 3.26722 9.02305 1.875 10 1.875C10.977 1.875 11.715 3.26722 12.632 3.64663C13.5165 4.01262 15.0262 3.5357 15.7452 4.25476C16.4643 4.97382 15.9874 6.48346 16.3534 7.36804C16.7328 8.28503 18.125 9.02305 18.125 10C18.125 10.977 16.7328 11.715 16.3534 12.632C15.9874 13.5165 16.4643 15.0262 15.7452 15.7452C15.0262 16.4643 13.5165 15.9874 12.632 16.3534C11.715 16.7328 10.9769 18.125 9.99997 18.125C9.02301 18.125 8.285 16.7328 7.36803 16.3534C6.48346 15.9874 4.97382 16.4643 4.25476 15.7452Z"
        fill="#0D99FF"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4375 8.125L8.85414 12.5L6.5625 10.3125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'diem-danh': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 12.5C12.7614 12.5 15 10.2614 15 7.5C15 4.73858 12.7614 2.5 10 2.5C7.23858 2.5 5 4.73858 5 7.5C5 10.2614 7.23858 12.5 10 12.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M2.4209 16.8743C3.1893 15.5442 4.29419 14.4398 5.62456 13.672C6.95493 12.9042 8.46393 12.5 9.99997 12.5C11.536 12.5 13.045 12.9043 14.3754 13.6721"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 14L14 18L12 16.0001"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  gear: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.0711 6.25 10 6.25C7.92893 6.25 6.25 7.92893 6.25 10C6.25 12.0711 7.92893 13.75 10 13.75Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.59963 3.44993L8.12545 2.34462C8.04635 2.28512 7.95425 2.24527 7.85673 2.22835C7.75921 2.21143 7.65906 2.21793 7.56455 2.2473C7.10798 2.39028 6.66502 2.57355 6.24091 2.79495C6.15311 2.841 6.07753 2.90727 6.02039 2.98829C5.96325 3.06931 5.9262 3.16276 5.9123 3.26092L5.6517 5.08521C5.55236 5.17326 5.45511 5.26485 5.35994 5.35996C5.26481 5.4551 5.1732 5.55237 5.08513 5.65179L5.08509 5.65182L3.26112 5.91265C3.16312 5.92651 3.06981 5.96346 2.98889 6.02045C2.90797 6.07744 2.84175 6.15285 2.79569 6.24046C2.57395 6.6644 2.39032 7.10721 2.24698 7.56366C2.21746 7.6583 2.21088 7.75861 2.22777 7.8563C2.24465 7.95399 2.28453 8.04627 2.34411 8.12551L3.4498 9.59975C3.44182 9.73225 3.43782 9.86578 3.43778 10.0003C3.43778 10.1349 3.44179 10.2684 3.44981 10.401L3.4498 10.4011L2.3445 11.8752C2.285 11.9543 2.24514 12.0464 2.22822 12.144C2.21131 12.2415 2.2178 12.3416 2.24718 12.4361C2.39016 12.8927 2.57343 13.3357 2.79483 13.7598C2.84088 13.8476 2.90715 13.9232 2.98817 13.9803C3.06919 14.0374 3.16264 14.0745 3.2608 14.0884L5.08509 14.349C5.17314 14.4483 5.26472 14.5456 5.35983 14.6407C5.45497 14.7359 5.55225 14.8275 5.65166 14.9156L5.65169 14.9156L5.91253 16.7396C5.92638 16.8376 5.96333 16.9309 6.02032 17.0118C6.07732 17.0927 6.15273 17.1589 6.24033 17.205C6.66427 17.4267 7.10708 17.6104 7.56353 17.7537C7.65818 17.7832 7.75848 17.7898 7.85617 17.7729C7.95387 17.756 8.04614 17.7161 8.12538 17.6566L9.59962 16.5509C9.73213 16.5589 9.86565 16.5629 10.0002 16.5629C10.1347 16.5629 10.2683 16.5589 10.4009 16.5509L10.4009 16.5509L11.8751 17.6562C11.9542 17.7157 12.0463 17.7555 12.1438 17.7725C12.2413 17.7894 12.3415 17.7829 12.436 17.7535C12.8926 17.6105 13.3355 17.4273 13.7596 17.2059C13.8474 17.1598 13.923 17.0935 13.9802 17.0125C14.0373 16.9315 14.0744 16.838 14.0883 16.7399L14.3489 14.9156C14.4482 14.8275 14.5454 14.736 14.6406 14.6408C14.7357 14.5457 14.8274 14.4484 14.9154 14.349L14.9155 14.349L16.7394 14.0881C16.8374 14.0743 16.9307 14.0373 17.0117 13.9804C17.0926 13.9234 17.1588 13.848 17.2049 13.7603C17.4266 13.3364 17.6102 12.8936 17.7536 12.4371C17.7831 12.3425 17.7897 12.2422 17.7728 12.1445C17.7559 12.0468 17.716 11.9545 17.6564 11.8753L16.5508 10.4011C16.5587 10.2686 16.5627 10.135 16.5628 10.0005C16.5628 9.86594 16.5588 9.73238 16.5507 9.5998L16.5508 9.59975L17.6561 8.12557C17.7156 8.04647 17.7554 7.95437 17.7723 7.85685C17.7893 7.75933 17.7828 7.65918 17.7534 7.56467C17.6104 7.1081 17.4271 6.66515 17.2057 6.24103C17.1597 6.15323 17.0934 6.07765 17.0124 6.02051C16.9314 5.96338 16.8379 5.92633 16.7398 5.91242L14.9155 5.65182C14.8274 5.55248 14.7358 5.45523 14.6407 5.36007C14.5456 5.26493 14.4483 5.17332 14.3489 5.08525L14.3489 5.08521L14.088 3.26124C14.0742 3.16324 14.0372 3.06993 13.9802 2.98901C13.9232 2.90809 13.8478 2.84187 13.7602 2.79581C13.3363 2.57407 12.8935 2.39044 12.437 2.2471C12.3424 2.21759 12.2421 2.211 12.1444 2.22789C12.0467 2.24478 11.9544 2.28466 11.8752 2.34423L10.4009 3.44993C10.2684 3.44195 10.1349 3.43794 10.0004 3.4379C9.86581 3.4379 9.73225 3.44191 9.59968 3.44993L9.59963 3.44993Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'white-down': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.76668 7.7418L10 10.9751L13.2333 7.7418C13.5583 7.4168 14.0834 7.4168 14.4083 7.7418C14.7333 8.0668 14.7333 8.5918 14.4083 8.9168L10.5833 12.7418C10.2583 13.0668 9.73335 13.0668 9.40835 12.7418L5.58335 8.9168C5.25835 8.5918 5.25835 8.0668 5.58335 7.7418C5.90835 7.42513 6.44168 7.4168 6.76668 7.7418Z"
        fill="white"
      />
    </svg>
  ),
  'icon-statistic': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_184_10368)">
        <path
          d="M3.4375 17.2496V13.5137H7.8125"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8125 17.25H2.1875"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.8125 17.25V11.0234H12.1875"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5625 8.5332H12.1875V17.2504H16.5625V8.5332Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.04779 11.2575C6.12347 9.2211 9.23522 7.0368 12.5 3.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M13.9071 5.15438L13.5752 2.04705L10.4679 2.37891"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_184_10368">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'logo-icon': (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_184_10359)">
        <path
          d="M11.6067 7.48552V2.6465H18.714C18.714 9.18674 18.714 -7.22058 18.714 13.9123C18.1847 14.2904 17.8445 14.8953 17.8823 15.6136C18.0335 18.0709 21.7384 17.9953 21.7384 15.5002C21.7384 14.8575 21.3981 14.2526 20.9067 13.9123C20.9067 11.077 20.9067 3.25138 20.9067 0.416016C18.2603 0.416016 13.1945 0.416016 9.37618 0.416016C9.33837 0.416016 9.37618 7.52333 9.37618 7.48552C9.37618 8.95991 11.6067 8.92211 11.6067 7.48552Z"
          fill="white"
        />
        <path
          d="M7.14568 19.0168H2.30666V11.9095C10.4347 11.9095 8.27982 11.9095 13.5725 11.9095C14.631 13.4217 17.0128 12.7034 17.0884 10.8888C17.164 8.96073 14.6688 8.12903 13.5725 9.71683C10.8506 9.71683 2.79812 9.71683 0.0761719 9.71683V21.2473C0.0761719 21.2851 7.18348 21.2473 7.14568 21.2473C8.65787 21.2095 8.62007 19.0168 7.14568 19.0168Z"
          fill="white"
        />
        <path
          d="M22.0409 10.8134C22.0409 12.2878 23.5153 11.9098 28.0141 11.9098V19.0171C21.4738 19.0171 37.8811 19.0171 16.7482 19.0171C16.3702 18.4878 15.7653 18.1476 15.047 18.1854C12.5897 18.3366 12.6653 22.0415 15.1604 22.0415C15.8031 22.0415 16.408 21.7012 16.7482 21.2098C30.736 21.2098 30.2445 21.2476 30.2445 21.2098V9.67928C23.2506 9.71708 22.0409 9.33903 22.0409 10.8134Z"
          fill="white"
        />
        <path
          d="M18.714 28.317H11.6067C11.6067 10.3219 11.6067 34.9707 11.6067 17.0512C12.1359 16.6731 12.4762 16.0683 12.4384 15.35C12.2871 12.8926 8.58228 12.9683 8.58228 15.4634C8.58228 16.1061 8.92251 16.7109 9.41398 17.0512C9.41398 24.6122 9.41398 22.9865 9.41398 30.5475C12.0603 30.5475 17.1262 30.5475 20.9445 30.5475C20.9823 30.5475 20.9445 23.4402 20.9445 23.478C20.9445 22.2305 19.5457 22.3817 19.8481 22.3817C18.3359 22.3439 18.714 23.8183 18.714 28.317Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_184_10359">
          <rect width="30.2439" height="30.2439" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'export-kq': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.71875 8.59473L10 11.8751L13.2812 8.59473"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.125V11.8727"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'printer-white': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 6.25V3.125H15V6.25"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.999 11.875H4.99902V17.1875H14.999V11.875Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99902 13.75H2.18652V7.5C2.18652 6.80964 2.7928 6.25 3.54069 6.25H16.4574C17.2052 6.25 17.8115 6.80964 17.8115 7.5V13.75H14.999"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6875 10C15.2053 10 15.625 9.58027 15.625 9.0625C15.625 8.54473 15.2053 8.125 14.6875 8.125C14.1697 8.125 13.75 8.54473 13.75 9.0625C13.75 9.58027 14.1697 10 14.6875 10Z"
        fill="white"
      />
    </svg>
  ),
  printer: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 6.25V3.125H15V6.25"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.999 11.875H4.99902V17.1875H14.999V11.875Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99902 13.75H2.18652V7.5C2.18652 6.80964 2.7928 6.25 3.54069 6.25H16.4574C17.2052 6.25 17.8115 6.80964 17.8115 7.5V13.75H14.999"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5625 9.0625C15.5625 9.54575 15.1707 9.9375 14.6875 9.9375C14.2043 9.9375 13.8125 9.54575 13.8125 9.0625C13.8125 8.57925 14.2043 8.1875 14.6875 8.1875C15.1707 8.1875 15.5625 8.57925 15.5625 9.0625Z"
        fill="#2260BD"
        stroke="#2260BD"
        strokeWidth="0.125"
      />
    </svg>
  ),
  'disease-history': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.875 10H4.375L7.5 3.125L12.5 16.25L15.625 10H18.125"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  transfer: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.625 2.5L18.125 10L10.625 17.5V13.75H8.125V6.25H10.625V2.5Z"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 13.75V6.25"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 13.75V6.25"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'chat-mess': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.54912 13.828C2.6173 12.2572 2.29097 10.4002 2.6314 8.60583C2.97184 6.81142 3.95563 5.203 5.39803 4.08261C6.84044 2.96222 8.64224 2.40692 10.4651 2.52099C12.2879 2.63506 14.0065 3.41065 15.2979 4.70212C16.5894 5.99359 17.365 7.71211 17.4791 9.53496C17.5932 11.3578 17.0379 13.1596 15.9175 14.602C14.7971 16.0444 13.1887 17.0282 11.3943 17.3687C9.59988 17.7091 7.74291 17.3828 6.17207 16.451L6.17209 16.4509L3.58173 17.191C3.47456 17.2216 3.36115 17.223 3.25325 17.1951C3.14536 17.1671 3.0469 17.1108 2.96809 17.032C2.88927 16.9532 2.83297 16.8547 2.80501 16.7468C2.77705 16.6389 2.77846 16.5255 2.80908 16.4184L3.54918 13.828L3.54912 13.828Z"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'money-circle': (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="18" fill="#E0F3F4" />
      <path
        d="M26.125 13H9.875C9.52982 13 9.25 13.2798 9.25 13.625V22.375C9.25 22.7202 9.52982 23 9.875 23H26.125C26.4702 23 26.75 22.7202 26.75 22.375V13.625C26.75 13.2798 26.4702 13 26.125 13Z"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 20.5C19.3807 20.5 20.5 19.3807 20.5 18C20.5 16.6193 19.3807 15.5 18 15.5C16.6193 15.5 15.5 16.6193 15.5 18C15.5 19.3807 16.6193 20.5 18 20.5Z"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.75 13L26.75 17.375"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.75 23L26.75 18.625"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 13L9.25 17.375"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 23L9.25 18.625"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'user-circle': (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="18" fill="#E3F3FE" />
      <path
        d="M14.875 19.5C17.1187 19.5 18.9375 17.6812 18.9375 15.4375C18.9375 13.1938 17.1187 11.375 14.875 11.375C12.6313 11.375 10.8125 13.1938 10.8125 15.4375C10.8125 17.6812 12.6313 19.5 14.875 19.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M20.1416 11.5263C20.7004 11.3688 21.2864 11.333 21.8602 11.4211C22.434 11.5092 22.9822 11.7193 23.468 12.0371C23.9538 12.355 24.3658 12.7732 24.6763 13.2637C24.9868 13.7542 25.1886 14.3055 25.2681 14.8806C25.3476 15.4557 25.303 16.0411 25.1372 16.5974C24.9714 17.1537 24.6883 17.6681 24.307 18.1058C23.9256 18.5435 23.4549 18.8944 22.9266 19.1349C22.3982 19.3754 21.8244 19.4999 21.2439 19.5"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25 22.4216C9.88448 21.5191 10.7268 20.7825 11.7058 20.274C12.6849 19.7655 13.7719 19.5 14.8751 19.5C15.9783 19.5 17.0653 19.7654 18.0444 20.2738C19.0234 20.7822 19.8658 21.5187 20.5004 22.4212"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2441 19.5C22.3475 19.4992 23.4347 19.7643 24.4139 20.2728C25.393 20.7813 26.2352 21.5182 26.8692 22.4212"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  send: (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="4" fill="#0D99FF" />
      <path
        d="M24.4263 10.8028L9.8694 14.9085C9.74694 14.9431 9.63793 15.0142 9.55696 15.1123C9.47598 15.2105 9.42689 15.331 9.41625 15.4578C9.40561 15.5846 9.43392 15.7116 9.49741 15.8219C9.56089 15.9322 9.65652 16.0204 9.77151 16.0749L16.4599 19.2431C16.5903 19.3049 16.6953 19.4099 16.7571 19.5404L19.9253 26.2287C19.9798 26.3437 20.068 26.4393 20.1783 26.5028C20.2886 26.5663 20.4156 26.5946 20.5424 26.584C20.6692 26.5733 20.7897 26.5242 20.8879 26.4433C20.986 26.3623 21.0571 26.2533 21.0917 26.1308L25.1974 11.574C25.2276 11.467 25.2287 11.354 25.2007 11.2465C25.1726 11.139 25.1164 11.0409 25.0379 10.9624C24.9593 10.8838 24.8612 10.8276 24.7537 10.7995C24.6462 10.7715 24.5332 10.7726 24.4263 10.8028Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6611 19.3388L20.1967 15.8032"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  building: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 6.33333V3H1.66669V18H18.3334V6.33333H10ZM5.00002 16.3333H3.33335V14.6667H5.00002V16.3333ZM5.00002 13H3.33335V11.3333H5.00002V13ZM5.00002 9.66667H3.33335V8H5.00002V9.66667ZM5.00002 6.33333H3.33335V4.66667H5.00002V6.33333ZM8.33335 16.3333H6.66669V14.6667H8.33335V16.3333ZM8.33335 13H6.66669V11.3333H8.33335V13ZM8.33335 9.66667H6.66669V8H8.33335V9.66667ZM8.33335 6.33333H6.66669V4.66667H8.33335V6.33333ZM16.6667 16.3333H10V14.6667H11.6667V13H10V11.3333H11.6667V9.66667H10V8H16.6667V16.3333ZM15 9.66667H13.3334V11.3333H15V9.66667ZM15 13H13.3334V14.6667H15V13Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  examination: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.875 5.625H3.125C2.77982 5.625 2.5 5.90482 2.5 6.25V16.25C2.5 16.5952 2.77982 16.875 3.125 16.875H16.875C17.2202 16.875 17.5 16.5952 17.5 16.25V6.25C17.5 5.90482 17.2202 5.625 16.875 5.625Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 5.625V4.375C13.125 4.04348 12.9933 3.72554 12.7589 3.49112C12.5245 3.2567 12.2065 3.125 11.875 3.125H8.125C7.79348 3.125 7.47554 3.2567 7.24112 3.49112C7.0067 3.72554 6.875 4.04348 6.875 4.375V5.625"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9.0625V13.4375"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1875 11.25H7.8125"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  export: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.71875 8.59473L10 11.8751L13.2812 8.59473"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.125V11.8727"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'cancel-video': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00065 1.3335C4.31398 1.3335 1.33398 4.3135 1.33398 8.00016C1.33398 11.6868 4.31398 14.6668 8.00065 14.6668C11.6873 14.6668 14.6673 11.6868 14.6673 8.00016C14.6673 4.3135 11.6873 1.3335 8.00065 1.3335ZM10.8673 10.8668C10.6073 11.1268 10.1873 11.1268 9.92732 10.8668L8.00065 8.94016L6.07398 10.8668C5.81398 11.1268 5.39398 11.1268 5.13398 10.8668C4.87398 10.6068 4.87398 10.1868 5.13398 9.92683L7.06065 8.00016L5.13398 6.0735C4.87398 5.8135 4.87398 5.3935 5.13398 5.1335C5.39398 4.8735 5.81398 4.8735 6.07398 5.1335L8.00065 7.06016L9.92732 5.1335C10.1873 4.8735 10.6073 4.8735 10.8673 5.1335C11.1273 5.3935 11.1273 5.8135 10.8673 6.0735L8.94065 8.00016L10.8673 9.92683C11.1207 10.1802 11.1207 10.6068 10.8673 10.8668Z"
        fill="#ED1117"
      />
    </svg>
  ),
  cancel: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke="#FF4648"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.5 7.5L7.5 12.5"
        stroke="#FF4648"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12.5L7.5 7.5"
        stroke="#FF4648"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  recall: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.23633 7.79004H2.48633V4.04004"
        stroke="#FEC328"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.13798 14.8614C6.09946 15.8229 7.32447 16.4776 8.65809 16.7429C9.99171 17.0082 11.374 16.872 12.6303 16.3517C13.8865 15.8313 14.9603 14.9501 15.7157 13.8196C16.4711 12.689 16.8743 11.3598 16.8743 10C16.8743 8.64026 16.4711 7.31105 15.7157 6.18046C14.9603 5.04987 13.8865 4.16868 12.6303 3.64833C11.374 3.12798 9.99171 2.99183 8.65809 3.2571C7.32447 3.52238 6.09946 4.17716 5.13798 5.13864L2.48633 7.79029"
        stroke="#FEC328"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  checks: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5625 6.5625L4.6875 13.4375L1.25 10.0002"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7498 6.5625L11.8748 13.4375L10.0488 11.6116"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'check-circle': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4375 8.125L8.85414 12.5L6.5625 10.3125"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'check-square': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.4375 11.1932V4.0625C3.4375 3.89674 3.50335 3.73777 3.62056 3.62056C3.73777 3.50335 3.89674 3.4375 4.0625 3.4375H15.9375C16.1033 3.4375 16.2622 3.50335 16.3794 3.62056C16.4967 3.73777 16.5625 3.89674 16.5625 4.0625V15.9375C16.5625 16.1033 16.4967 16.2622 16.3794 16.3794C16.2622 16.4967 16.1033 16.5625 15.9375 16.5625H10.5966"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.875L5 16.875L2.5 14.375"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'plus-circle': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.875 10H13.125"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.875V13.125"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'time-discount': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M10 10H14.375"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0936 13.0936L10 10"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  csyt: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.25 17.3738H18.75"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 17.3735V3.62354C11.25 3.45777 11.1842 3.2988 11.0669 3.18159C10.9497 3.06438 10.7908 2.99854 10.625 2.99854H3.125C2.95924 2.99854 2.80027 3.06438 2.68306 3.18159C2.56585 3.2988 2.5 3.45777 2.5 3.62354V17.3735"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 17.3735V8.62354C17.5 8.45777 17.4342 8.2988 17.3169 8.18159C17.1997 8.06438 17.0408 7.99854 16.875 7.99854H11.25"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 6.12354H7.5"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 11.1235H8.75"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 14.2485H7.5"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 14.2485H15"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 11.1235H15"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'warning-import': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 9.75V13.5"
        stroke="#FEC328"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7018 3.74857L2.45402 17.9978C2.32204 18.2258 2.25245 18.4846 2.25223 18.748C2.25201 19.0115 2.32118 19.2703 2.45278 19.4986C2.58437 19.7268 2.77376 19.9163 3.00187 20.0481C3.22999 20.1799 3.48879 20.2493 3.75223 20.2493H20.2478C20.5112 20.2493 20.77 20.1799 20.9981 20.0481C21.2263 19.9163 21.4156 19.7268 21.5472 19.4986C21.6788 19.2703 21.748 19.0115 21.7478 18.748C21.7476 18.4846 21.678 18.2258 21.546 17.9978L13.2982 3.74857C13.1664 3.52093 12.9771 3.33193 12.7493 3.20055C12.5214 3.06916 12.263 3 12 3C11.737 3 11.4786 3.06916 11.2507 3.20055C11.0229 3.33193 10.8336 3.52093 10.7018 3.74857V3.74857Z"
        stroke="#FEC328"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18C12.6213 18 13.125 17.4963 13.125 16.875C13.125 16.2537 12.6213 15.75 12 15.75C11.3787 15.75 10.875 16.2537 10.875 16.875C10.875 17.4963 11.3787 18 12 18Z"
        fill="#FEC328"
      />
    </svg>
  ),
  cloud: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12.586L16.243 16.828L14.828 18.243L13 16.415V22H11V16.413L9.17202 18.243L7.75702 16.828L12 12.586ZM12 2C13.717 2.00008 15.3741 2.63111 16.6562 3.77312C17.9383 4.91512 18.7561 6.48846 18.954 8.194C20.1983 8.53332 21.2837 9.2991 22.0207 10.3575C22.7576 11.416 23.0992 12.6997 22.9856 13.9844C22.8721 15.2691 22.3107 16.473 21.3996 17.3858C20.4884 18.2986 19.2855 18.8622 18.001 18.978V16.964C18.4612 16.8983 18.9037 16.7416 19.3026 16.503C19.7015 16.2644 20.049 15.9487 20.3246 15.5744C20.6002 15.2001 20.7985 14.7746 20.9079 14.3228C21.0173 13.8711 21.0356 13.402 20.9617 12.9431C20.8879 12.4841 20.7233 12.0445 20.4777 11.6498C20.2321 11.2552 19.9104 10.9134 19.5312 10.6445C19.1521 10.3755 18.7232 10.1848 18.2695 10.0834C17.8159 9.98203 17.3466 9.97203 16.889 10.054C17.0456 9.32489 17.0372 8.56997 16.8642 7.84455C16.6913 7.11913 16.3583 6.44158 15.8896 5.86153C15.4209 5.28147 14.8284 4.81361 14.1555 4.49219C13.4826 4.17078 12.7463 4.00397 12.0005 4.00397C11.2548 4.00397 10.5185 4.17078 9.84554 4.49219C9.17262 4.81361 8.58011 5.28147 8.11142 5.86153C7.64273 6.44158 7.30972 7.11913 7.1368 7.84455C6.96387 8.56997 6.95541 9.32489 7.11202 10.054C6.19967 9.88267 5.25663 10.0808 4.49036 10.6048C3.72409 11.1287 3.19735 11.9357 3.02602 12.848C2.85469 13.7603 3.0528 14.7034 3.57678 15.4697C4.10075 16.2359 4.90767 16.7627 5.82002 16.934L6.00002 16.964V18.978C4.71547 18.8623 3.51242 18.2989 2.60115 17.3862C1.68988 16.4735 1.12834 15.2696 1.01469 13.9848C0.901037 12.7001 1.2425 11.4163 1.97939 10.3578C2.71627 9.29926 3.80172 8.53339 5.04602 8.194C5.24372 6.48838 6.06142 4.91491 7.3436 3.77287C8.62577 2.63082 10.283 1.99986 12 2V2Z"
        fill="#6A7688"
      />
    </svg>
  ),
  quanlysuckhoe: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 11.875H12.5"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.375H12.5"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5002 3.125H15.625C15.7908 3.125 15.9497 3.19085 16.0669 3.30806C16.1842 3.42527 16.25 3.58424 16.25 3.75V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.75C3.75 3.58424 3.81585 3.42527 3.93306 3.30806C4.05027 3.19085 4.20924 3.125 4.375 3.125H7.49983"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 5.625V5C6.875 4.1712 7.20424 3.37634 7.79029 2.79029C8.37634 2.20424 9.1712 1.875 10 1.875C10.8288 1.875 11.6237 2.20424 12.2097 2.79029C12.7958 3.37634 13.125 4.1712 13.125 5V5.625H6.875Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  cauhinhdichvu: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.25 16.25V3.75C16.25 3.05964 15.6904 2.5 15 2.5L5 2.5C4.30964 2.5 3.75 3.05964 3.75 3.75V16.25C3.75 16.9404 4.30964 17.5 5 17.5H15C15.6904 17.5 16.25 16.9404 16.25 16.25Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 5H12.5"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  quanlychung: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 13.125C10.6066 13.125 13.125 10.6066 13.125 7.5C13.125 4.3934 10.6066 1.875 7.5 1.875C4.3934 1.875 1.875 4.3934 1.875 7.5C1.875 10.6066 4.3934 13.125 7.5 13.125Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 18.125C15.6066 18.125 18.125 15.6066 18.125 12.5C18.125 9.3934 15.6066 6.875 12.5 6.875C9.3934 6.875 6.875 9.3934 6.875 12.5C6.875 15.6066 9.3934 18.125 12.5 18.125Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.57166 7.69727L12.3035 10.4291"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.69653 9.57227L10.4284 12.3041"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'management-skdn': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.875 12.5C9.11866 12.5 10.9375 10.6812 10.9375 8.4375C10.9375 6.19384 9.11866 4.375 6.875 4.375C4.63134 4.375 2.8125 6.19384 2.8125 8.4375C2.8125 10.6812 4.63134 12.5 6.875 12.5Z"
        stroke="#212529"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.1406 4.52726C12.6994 4.36983 13.2854 4.33396 13.8592 4.42208C14.433 4.5102 14.9812 4.72026 15.467 5.0381C15.9528 5.35595 16.3648 5.7742 16.6753 6.26469C16.9859 6.75519 17.1877 7.30652 17.2672 7.88158C17.3467 8.45663 17.302 9.04204 17.1362 9.59838C16.9704 10.1547 16.6873 10.6691 16.306 11.1068C15.9247 11.5445 15.454 11.8954 14.9256 12.1359C14.3972 12.3764 13.8235 12.5009 13.2429 12.5009"
        stroke="#212529"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.25 15.4216C1.88448 14.5191 2.72679 13.7825 3.70582 13.274C4.68485 12.7655 5.77186 12.5 6.87507 12.5C7.97828 12.5 9.0653 12.7654 10.0444 13.2738C11.0234 13.7822 11.8658 14.5187 12.5004 15.4212"
        stroke="#212529"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2441 12.5C14.3475 12.4992 15.4347 12.7643 16.4139 13.2728C17.393 13.7813 18.2352 14.5182 18.8692 15.4212"
        stroke="#212529"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'pen-black': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667L2 11.5ZM3.94667 12.6667H3.33333V12.0533L9.37333 6.01333L9.98667 6.62667L3.94667 12.6667ZM13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2C11.6 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333Z"
        fill="#222D4B"
      />
    </svg>
  ),
  'pen-primary': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667L2 11.5ZM3.94667 12.6667H3.33333V12.0533L9.37333 6.01333L9.98667 6.62667L3.94667 12.6667ZM13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2C11.6 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  'upload-success': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  'upload-green': (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 24H22.5V15H28.5L18 4.5L7.5 15H13.5V24ZM18 8.745L21.255 12H19.5V21H16.5V12H14.745L18 8.745ZM7.5 27H28.5V30H7.5V27Z"
        fill="#00C968"
      />
    </svg>
  ),
  'dot-border': (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="4" cy="4" r="3.5" fill="white" stroke="#222D4B" />
    </svg>
  ),
  'plus-plus': (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.66634 5.66732H5.66634V9.66732H4.33301V5.66732H0.333008V4.33398H4.33301V0.333984H5.66634V4.33398H9.66634V5.66732Z"
        fill="#222D4B"
      />
    </svg>
  ),
  'apart-apart': (
    <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.66634 1.66732H0.333008V0.333984H9.66634V1.66732Z" fill="#222D4B" />
    </svg>
  ),
  'rectangle-black': (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="8" height="8" fill="#222D4B" />
    </svg>
  ),
  'square-square': (
    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="5" height="5" fill="white" stroke="#C5CED9" />
    </svg>
  ),
  eraser: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5168_17024)">
        <path
          d="M14.0205 6L21.0916 13.0711L13.1419 21.0208L6.99963 21.0208L2.99969 17.0208L14.0205 6Z"
          stroke="#626262"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path d="M9.5 11L14 6.5L20.5 13L16 17.5L9.5 11Z" fill="#626262" />
      </g>
      <defs>
        <clipPath id="clip0_5168_17024">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'edit-primary': (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02V6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0V0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19V3.19Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  'white-upload': (
    <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 13H10V7H14L7 0L0 7H4V13ZM7 2.83L9.17 5H8V11H6V5H4.83L7 2.83ZM0 15H14V17H0V15Z"
        fill="white"
      />
    </svg>
  ),
  'red-warning': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00033 3.99398L13.0203 12.6673H2.98033L8.00033 3.99398ZM8.00033 1.33398L0.666992 14.0007H15.3337L8.00033 1.33398ZM8.66699 10.6673H7.33366V12.0007H8.66699V10.6673ZM8.66699 6.66732H7.33366V9.33398H8.66699V6.66732Z"
        fill="#E50500"
      />
    </svg>
  ),
  'black-dot': (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="4" cy="4" r="4" fill="#222D4B" />
    </svg>
  ),
  'expire-date-sign': (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4831_16432)">
        <path
          d="M24.9992 11.1104C17.3604 11.1104 11.1104 17.3604 11.1104 24.9992C11.1104 32.6381 17.3604 38.8881 24.9992 38.8881C32.6381 38.8881 38.8881 32.6381 38.8881 24.9992C38.8881 17.3604 32.6381 11.1104 24.9992 11.1104ZM24.9992 36.1103C18.8742 36.1103 13.8881 31.1242 13.8881 24.9992C13.8881 18.8742 18.8742 13.8881 24.9992 13.8881C31.1242 13.8881 36.1103 18.8742 36.1103 24.9992C36.1103 31.1242 31.1242 36.1103 24.9992 36.1103ZM25.6937 18.0548H23.6103V26.3881L30.8326 30.8326L31.9437 29.027L25.6937 25.277V18.0548Z"
          fill="#E50500"
        />
      </g>
      <circle cx="25" cy="25" r="24.5" stroke="#E50500" strokeDasharray="5 5" />
      <defs>
        <clipPath id="clip0_4831_16432">
          <rect
            width="33.3333"
            height="33.3333"
            fill="white"
            transform="translate(8.33301 8.33301)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  'zoom-in': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.5" width="24" height="24" rx="4" fill="#222D4B" />
      <path
        d="M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z"
        fill="white"
      />
    </svg>
  ),
  'zoom-out': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#0D99FF" />
      <path
        d="M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z"
        fill="white"
      />
    </svg>
  ),
  'arrow-down-primary': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 10L12 15L17 10H7Z" fill={'#0D99FF'} />
    </svg>
  ),
  'arrow-up-primary': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 14L12 9L17 14H7Z" fill={'#0D99FF'} />
    </svg>
  ),
  'arrow-down-primary-black': (
    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0L5 5L10 0H0Z" fill="#323232" />
    </svg>
  ),
  'arrow-up-primary-black': (
    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 5L5 0L10 5H0Z" fill="#323232" />
    </svg>
  ),
  pin: (
    <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4412_19837)">
        <path
          d="M18.6293 10.4433L14.658 19.1651C13.8948 20.8411 11.9191 21.5806 10.243 20.8174C8.56689 20.0542 7.82747 18.0785 8.59066 16.4024L12.9073 6.92223C13.3839 5.87562 14.6201 5.41297 15.6667 5.88953C16.7133 6.36609 17.1759 7.60228 16.6994 8.64889L13.0734 16.6122C12.8835 17.0294 12.3868 17.2152 11.9696 17.0253C11.5525 16.8354 11.3666 16.3387 11.5566 15.9216L14.8372 8.71664L13.6996 8.19864L10.4189 15.4036C9.94238 16.4502 10.405 17.6864 11.4516 18.1629C12.4983 18.6395 13.7344 18.1768 14.211 17.1302L17.837 9.16689C18.6002 7.4908 17.8608 5.5151 16.1847 4.75191C14.5086 3.98873 12.5329 4.72814 11.7697 6.40423L7.45304 15.8844C6.40323 18.19 7.41941 20.9052 9.72498 21.955C12.0306 23.0048 14.7458 21.9886 15.7956 19.6831L19.7669 10.9613L18.6293 10.4433Z"
          fill="#0D99FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_4412_19837">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.106445 18.9487) rotate(-65.5185)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  copyVBM: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
        fill="#8E24AA"
      />
    </svg>
  ),
  emptySign: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
        fill="#E50500"
      />
    </svg>
  ),
  empty: (
    <svg width="97" height="62" viewBox="0 0 97 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M48.5 61.9989C75.2858 61.9989 97 57.2596 97 51.4135C97 45.5674 75.2858 40.8281 48.5 40.8281C21.7142 40.8281 0 45.5674 0 51.4135C0 57.2596 21.7142 61.9989 48.5 61.9989Z"
        fill="#DCDCDC"
      />
      <path
        d="M83.3594 20.8082L67.9823 3.41315C67.2444 2.22824 66.1659 1.51172 65.0306 1.51172H31.9694C30.8341 1.51172 29.7556 2.22842 29.0177 3.41315L13.6406 20.8082L13.6406 34.78H83.3594V20.8082Z"
        stroke="#B3AAAA"
      />
      <path
        d="M63.0701 25.6029C63.0701 23.1749 64.5762 21.1703 66.4445 21.1699H83.3594V48.5968C83.3594 51.8054 81.3578 54.4382 78.8889 54.4382H18.1111C15.642 54.4382 13.6406 51.8052 13.6406 48.5968V21.1699H30.5555C32.4238 21.1699 33.9299 23.1703 33.9299 25.5983V25.6304C33.9299 28.0584 35.4531 30.0181 37.3214 30.0181H59.6786C61.5469 30.0181 63.0701 28.0404 63.0701 25.6123V25.6029Z"
        fill="#FAFAFA"
        stroke="#B3AAAA"
      />
    </svg>
  ),
  uploadVBMIcon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.71875 6.40539L10 3.125L13.2812 6.40539"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.8747V3.12695"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  settingVBM: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.4308 12.98C19.4708 12.66 19.5008 12.34 19.5008 12C19.5008 11.66 19.4708 11.34 19.4308 11.02L21.5408 9.37C21.7308 9.22 21.7808 8.95 21.6608 8.73L19.6608 5.27C19.5708 5.11 19.4008 5.02 19.2208 5.02C19.1608 5.02 19.1008 5.03 19.0508 5.05L16.5608 6.05C16.0408 5.65 15.4808 5.32 14.8708 5.07L14.4908 2.42C14.4608 2.18 14.2508 2 14.0008 2H10.0008C9.75082 2 9.54082 2.18 9.51082 2.42L9.13082 5.07C8.52082 5.32 7.96082 5.66 7.44082 6.05L4.95082 5.05C4.89082 5.03 4.83082 5.02 4.77082 5.02C4.60082 5.02 4.43082 5.11 4.34082 5.27L2.34082 8.73C2.21082 8.95 2.27082 9.22 2.46082 9.37L4.57082 11.02C4.53082 11.34 4.50082 11.67 4.50082 12C4.50082 12.33 4.53082 12.66 4.57082 12.98L2.46082 14.63C2.27082 14.78 2.22082 15.05 2.34082 15.27L4.34082 18.73C4.43082 18.89 4.60082 18.98 4.78082 18.98C4.84082 18.98 4.90082 18.97 4.95082 18.95L7.44082 17.95C7.96082 18.35 8.52082 18.68 9.13082 18.93L9.51082 21.58C9.54082 21.82 9.75082 22 10.0008 22H14.0008C14.2508 22 14.4608 21.82 14.4908 21.58L14.8708 18.93C15.4808 18.68 16.0408 18.34 16.5608 17.95L19.0508 18.95C19.1108 18.97 19.1708 18.98 19.2308 18.98C19.4008 18.98 19.5708 18.89 19.6608 18.73L21.6608 15.27C21.7808 15.05 21.7308 14.78 21.5408 14.63L19.4308 12.98V12.98ZM17.4508 11.27C17.4908 11.58 17.5008 11.79 17.5008 12C17.5008 12.21 17.4808 12.43 17.4508 12.73L17.3108 13.86L18.2008 14.56L19.2808 15.4L18.5808 16.61L17.3108 16.1L16.2708 15.68L15.3708 16.36C14.9408 16.68 14.5308 16.92 14.1208 17.09L13.0608 17.52L12.9008 18.65L12.7008 20H11.3008L11.1108 18.65L10.9508 17.52L9.89082 17.09C9.46082 16.91 9.06082 16.68 8.66082 16.38L7.75082 15.68L6.69082 16.11L5.42082 16.62L4.72082 15.41L5.80082 14.57L6.69082 13.87L6.55082 12.74C6.52082 12.43 6.50082 12.2 6.50082 12C6.50082 11.8 6.52082 11.57 6.55082 11.27L6.69082 10.14L5.80082 9.44L4.72082 8.6L5.42082 7.39L6.69082 7.9L7.73082 8.32L8.63082 7.64C9.06082 7.32 9.47082 7.08 9.88082 6.91L10.9408 6.48L11.1008 5.35L11.3008 4H12.6908L12.8808 5.35L13.0408 6.48L14.1008 6.91C14.5308 7.09 14.9308 7.32 15.3308 7.62L16.2408 8.32L17.3008 7.89L18.5708 7.38L19.2708 8.59L18.2008 9.44L17.3108 10.14L17.4508 11.27ZM12.0008 8C9.79082 8 8.00082 9.79 8.00082 12C8.00082 14.21 9.79082 16 12.0008 16C14.2108 16 16.0008 14.21 16.0008 12C16.0008 9.79 14.2108 8 12.0008 8ZM12.0008 14C10.9008 14 10.0008 13.1 10.0008 12C10.0008 10.9 10.9008 10 12.0008 10C13.1008 10 14.0008 10.9 14.0008 12C14.0008 13.1 13.1008 14 12.0008 14Z"
        fill="#F57C00"
      />
    </svg>
  ),
  starOrange: (
    <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.99935 5.75797L6.05935 7.0013L5.51268 4.65797L7.33268 3.0813L4.93602 2.87797L3.99935 0.667969L3.06268 2.87797L0.666016 3.0813L2.48602 4.65797L1.93935 7.0013L3.99935 5.75797Z"
        fill="#F57C00"
      />
    </svg>
  ),
  logoHome: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.2496 9.34999V2.95H24.6496C24.6496 11.6 24.6496 -10.1 24.6496 17.85C23.9496 18.35 23.4996 19.15 23.5496 20.1C23.7496 23.35 28.6496 23.25 28.6496 19.95C28.6496 19.1 28.1996 18.3 27.5496 17.85C27.5496 14.1 27.5496 3.75 27.5496 0C24.0496 0 17.3496 0 12.2996 0C12.2496 0 12.2996 9.39999 12.2996 9.34999C12.2996 11.3 15.2496 11.25 15.2496 9.34999Z"
        fill="white"
      />
      <path
        d="M9.34999 24.6009H2.95V15.2009C13.7 15.2009 10.85 15.2009 17.85 15.2009C19.25 17.2009 22.4 16.2509 22.5 13.8509C22.6 11.3009 19.3 10.201 17.85 12.301C14.25 12.301 3.6 12.301 0 12.301V27.551C0 27.601 9.39999 27.551 9.34999 27.551C11.35 27.501 11.3 24.6009 9.34999 24.6009Z"
        fill="white"
      />
      <path
        d="M29.0501 13.7512C29.0501 15.7012 31.0001 15.2012 36.9501 15.2012V24.6012C28.3001 24.6012 50.0001 24.6012 22.0501 24.6012C21.5501 23.9012 20.7501 23.4512 19.8001 23.5012C16.5501 23.7012 16.6501 28.6012 19.9501 28.6012C20.8001 28.6012 21.6001 28.1512 22.0501 27.5012C40.5501 27.5012 39.9001 27.5512 39.9001 27.5012V12.2512C30.6501 12.3012 29.0501 11.8012 29.0501 13.7512Z"
        fill="white"
      />
      <path
        d="M24.65 36.9013H15.25C15.25 13.1013 15.25 45.7013 15.25 22.0013C15.95 21.5013 16.4 20.7013 16.35 19.7513C16.15 16.5013 11.25 16.6013 11.25 19.9013C11.25 20.7513 11.7 21.5513 12.35 22.0013C12.35 32.0013 12.35 29.8513 12.35 39.8513C15.85 39.8513 22.55 39.8513 27.6 39.8513C27.65 39.8513 27.6 30.4513 27.6 30.5013C27.6 28.8513 25.75 29.0513 26.15 29.0513C24.15 29.0013 24.65 30.9513 24.65 36.9013Z"
        fill="white"
      />
    </svg>
  ),
  writeVBM: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="49" stroke="#8E24AA" strokeWidth="2" />
      <path
        d="M54.2917 43.7917L56.2083 45.7083L37.3333 64.5833H35.4167V62.6667L54.2917 43.7917V43.7917ZM61.7917 31.25C61.2708 31.25 60.7292 31.4583 60.3333 31.8542L56.5208 35.6667L64.3333 43.4792L68.1458 39.6667C68.9583 38.8542 68.9583 37.5417 68.1458 36.7292L63.2708 31.8542C62.8542 31.4375 62.3333 31.25 61.7917 31.25V31.25ZM54.2917 37.8958L31.25 60.9375V68.75H39.0625L62.1042 45.7083L54.2917 37.8958V37.8958Z"
        fill="#8E24AA"
      />
    </svg>
  ),
  uploadVBM: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="49" stroke="#00C968" strokeWidth="2" />
      <path
        d="M43.7493 58.3333H56.2494V45.8333H64.5827L49.9993 31.25L35.416 45.8333H43.7493V58.3333ZM49.9993 37.1458L54.5202 41.6667H52.0827V54.1667H47.916V41.6667H45.4785L49.9993 37.1458ZM35.416 62.5H64.5827V66.6667H35.416V62.5Z"
        fill="#00C968"
      />
    </svg>
  ),
  sign: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 0H3C1.34325 0 0 1.34325 0 3V21C0 22.6568 1.34325 24 3 24H11.25V22.5H3C2.17387 22.5 1.5 21.8276 1.5 21V3C1.5 2.17237 2.17387 1.5 3 1.5H18C18.8276 1.5 19.5 2.17237 19.5 3V11.8183L21 10.3183V3C21 1.34325 19.6568 0 18 0Z"
        fill="#8E24AA"
      />
      <path
        d="M23.5605 13.5L22.5 12.4395C22.2069 12.1464 21.8233 12 21.4395 12C21.0557 12 20.6719 12.1464 20.379 12.4395L13.9395 18.879C13.6464 19.1721 12.7504 20.3049 12.75 20.6887L12 24L15.3105 23.25C15.3105 23.25 16.8281 22.3536 17.121 22.0605L23.5605 15.621C24.1464 15.0352 24.1464 14.0852 23.5605 13.5ZM16.5922 21.5287C16.5073 21.6094 16.2135 21.8078 15.8546 22.0363L13.9116 20.0933C14.1109 19.8201 14.3327 19.5454 14.4697 19.4092L19.3183 14.5607L21.4395 16.6819L16.5922 21.5287Z"
        fill="#8E24AA"
      />
      <path opacity="0.3" d="M16.5 6H4.5V4.5H16.5V6Z" fill="#8E24AA" />
      <path opacity="0.3" d="M16.5 9H4.5V7.5H16.5V9Z" fill="#8E24AA" />
      <path opacity="0.3" d="M16.5 12H4.5V10.5H16.5V12Z" fill="#8E24AA" />
      <path opacity="0.3" d="M10.5 15H4.5V13.5H10.5V15Z" fill="#8E24AA" />
    </svg>
  ),
  iconSigned: (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2210_12464)">
        <path
          d="M14.3242 8.95268C14.4809 8.97506 14.6376 9.01982 14.8166 9.06458L15.1747 9.98222L15.6223 9.15411C15.9357 9.15411 16.249 9.17649 16.5624 9.17649L15.9581 8.39314C15.9804 8.326 16.0028 8.25885 16.0252 8.19171C15.9581 8.16933 15.8909 8.14695 15.7566 8.10219C15.9581 7.90075 16.0476 7.81123 16.1595 7.85599C16.2043 7.74408 16.249 7.60979 16.2938 7.49789C15.9804 7.58741 15.6671 7.7217 15.3538 7.83361C15.1747 7.69932 14.9957 7.58741 14.8166 7.45312C14.8166 7.60979 14.839 7.78885 14.7718 7.99028C14.6823 7.78885 14.6152 7.63218 14.548 7.52027C14.5704 7.76646 14.5704 8.03504 14.5928 8.28124C14.5704 8.30362 14.5257 8.326 14.5033 8.37076C14.5928 8.37076 14.6823 8.37076 14.7942 8.37076C14.7942 8.66172 14.6823 8.84077 14.3242 8.95268Z"
          fill="#00C968"
        />
        <path
          d="M13.8545 8.86288C13.8993 8.86288 13.944 8.88527 13.9888 8.88527C13.9888 8.8405 13.9888 8.79574 13.9888 8.75098C13.9216 8.79574 13.8993 8.81812 13.8545 8.86288Z"
          fill="#00C968"
        />
        <path
          d="M20.1208 5.93097C19.9194 5.68477 19.6956 5.43858 19.4718 5.19238C19.4046 5.5281 19.3375 5.84144 19.2927 6.17716L18.8451 6.3786L18.3975 6.60241C18.7108 6.7367 19.0018 6.87099 19.2927 7.02766L19.427 7.99006L20.0761 7.31861C20.3894 7.38576 20.6804 7.49766 20.9713 7.58719L20.5908 6.69193C20.7699 6.42336 20.9489 6.1324 21.128 5.86382C20.7923 5.86382 20.4565 5.90859 20.1208 5.93097Z"
          fill="#00C968"
        />
        <path
          d="M10.9897 12.1309L11.5716 12.9142C11.6387 12.6009 11.7283 12.3099 11.8178 11.9966C12.1087 11.907 12.4445 11.8623 12.7354 11.7951L11.9521 11.1908C11.9744 10.8775 11.9968 10.5418 12.0416 10.2061C11.7506 10.3851 11.4821 10.5865 11.2135 10.7656C10.9001 10.6537 10.5868 10.5418 10.2735 10.4299C10.363 10.7432 10.4749 11.0565 10.5868 11.3699C10.3854 11.6385 10.1839 11.907 10.0049 12.1756C10.3406 12.1756 10.6539 12.1532 10.9897 12.1309Z"
          fill="#00C968"
        />
        <path
          d="M18.1292 35.8776C18.1515 35.6538 18.1292 35.5867 17.9053 35.4748C17.5696 35.3181 17.9501 35.139 18.0396 34.9824C17.9501 34.8929 17.9053 34.8257 17.7934 34.6914C18.0396 34.5795 18.2635 34.4676 18.5096 34.3333C18.6216 34.7138 18.7111 35.0271 18.8006 35.3629C19.2706 35.3629 19.4273 35.721 19.6287 36.1462C19.2259 36.0567 19.3154 35.9672 19.1587 36.4595L22.8293 38.5858C22.8069 38.4291 22.8516 38.2948 23.0083 38.2724C23.0978 38.2501 23.2097 38.2948 23.2769 38.3396L25.1122 35.1614C25.0674 35.1614 25.045 35.1838 25.0002 35.1838C24.9555 35.1838 24.9107 35.0719 24.9107 35.0495C24.9331 35.0048 25.0002 34.96 25.1122 34.8928C25.1345 34.96 25.1569 35.0048 25.1793 35.0495L25.9403 33.7514C25.8507 33.729 25.7388 33.7066 25.5598 33.6395C25.7388 33.5723 25.9179 33.4828 26.0969 33.5052L26.6788 32.4757C26.5893 32.5204 26.4998 32.5652 26.3655 32.5876C26.1193 31.9161 26.3431 31.5804 27.0817 31.5804C27.0593 31.6923 27.0369 31.7818 27.0146 31.8937L30.797 25.3584C30.7523 25.4031 30.7299 25.4255 30.6627 25.4703C30.6851 25.1346 30.7075 24.9331 30.9985 25.0003L33.4828 20.7031C33.4604 20.6583 33.4156 20.5688 33.3709 20.4792C33.438 20.4792 33.5276 20.4792 33.5947 20.5016L37.1533 14.3244L30.5508 10.5195L20.3002 28.2903L13.7872 24.5303L9.95996 31.1552L18.1292 35.8776Z"
          fill="#00C968"
        />
        <path
          d="M0 25.0001C0 25.0896 0 25.1567 0 25.2463C0.0447628 25.2239 0.0895255 25.2015 0.179051 25.2015C0.201432 25.2015 0.290958 25.3134 0.268577 25.3134C0.201432 25.4029 0.15667 25.5148 0.0671442 25.5596C0.0447628 25.5596 0.0223814 25.582 0 25.582C0.0223814 26.9025 0.15667 28.2006 0.402865 29.4764C0.470009 29.4316 0.514772 29.3644 0.559535 29.2749C0.626679 29.1406 0.895255 29.0959 1.09669 29.0063C1.16383 28.6035 0.738586 28.7154 0.581916 28.5363C0.49239 28.2006 0.425246 27.8649 0.290958 27.3725C0.760967 27.7082 0.984781 28.1335 1.38765 28.3349C1.49955 28.3797 1.61146 28.4468 1.72337 28.514C1.70099 28.2901 1.65622 28.0887 1.63384 27.8649C1.41003 27.932 1.20859 27.9768 1.00716 27.753C0.581916 27.2606 0.783348 26.7906 0.80573 26.6339C1.09669 26.522 1.3205 26.4772 1.49955 26.5444C1.47717 26.3206 1.47717 26.0968 1.45479 25.8506C1.41003 25.8506 1.38765 25.8282 1.34288 25.8282C1.09669 25.7163 1.25336 25.582 1.36526 25.4029C1.38765 25.4253 1.41003 25.4477 1.43241 25.4701C1.38765 23.6124 1.5667 21.7772 1.96956 20.009C1.79051 19.8524 1.74575 19.7181 1.79051 19.5614C1.83527 19.4271 1.9248 19.36 2.12623 19.3824C3.9615 11.9517 9.35542 5.61781 16.8979 2.8649C16.8308 2.79775 16.7637 2.73061 16.6741 2.66346C16.8532 2.6187 16.9651 2.57394 17.1441 2.52918C17.1218 2.6187 17.1218 2.70823 17.1218 2.79775C17.547 2.64108 17.9946 2.50679 18.4423 2.37251C18.3751 2.17107 18.2856 1.94726 18.1961 1.67868C18.4199 1.74583 19.3151 1.85773 19.0913 2.19345C22.5381 1.2982 26.0295 1.20867 29.3196 1.83535C29.2972 1.81297 29.2972 1.81297 29.2748 1.79059C29.7225 1.67868 29.7672 1.6563 29.9687 1.96964C30.5058 2.08155 31.0206 2.21584 31.5354 2.37251C31.5577 2.35012 31.5801 2.30536 31.6249 2.2606C31.6473 2.32774 31.6697 2.37251 31.692 2.41727C34.333 3.20062 36.795 4.43159 39.0107 6.06543C39.0107 5.99829 39.0107 5.90876 38.9884 5.75209C39.4136 5.95353 39.3689 5.81924 39.2569 6.2221C39.2346 6.2221 39.2122 6.19972 39.1898 6.19972C43.2408 9.24359 46.3518 13.6303 47.7619 18.89C51.1191 31.4235 43.6437 44.3824 31.1101 47.7396C29.8568 48.0753 28.6034 48.2991 27.3277 48.4334C27.4172 48.5677 27.5515 48.6796 27.5739 48.8139C27.6634 49.3734 27.2381 49.4182 26.6338 49.6867C26.88 49.2167 27.0591 48.8362 27.2605 48.4334C26.0072 48.5453 24.7314 48.5677 23.5005 48.5005C23.6124 48.6348 23.6571 48.702 23.5676 48.9929C23.5676 49.0153 23.3885 49.0153 23.3662 48.9929C23.2319 48.7691 23.3214 48.6124 23.3885 48.5005C23.12 48.4781 22.8514 48.4558 22.5828 48.4334V48.4558C22.4933 48.4558 22.4261 48.4334 22.3814 48.411C20.9937 48.2543 19.6061 47.9634 18.2856 47.5605C18.5765 47.9186 18.487 48.0305 17.9499 48.3439C17.9722 48.1648 18.0618 47.9634 18.017 47.8738C17.9275 47.7172 17.9499 47.6053 18.017 47.4934C16.2936 46.9562 14.6374 46.2176 13.0931 45.3C12.8022 45.3 12.735 45.3 12.6679 45.0538C12.4888 44.9419 12.3098 44.83 12.1531 44.7181C12.1083 44.7628 12.1083 44.7405 11.9964 44.6733C11.9964 44.6509 12.0188 44.6509 12.0188 44.6285C7.38586 41.5623 3.82722 36.8622 2.2829 31.1102C2.12623 30.5283 1.99194 29.924 1.88004 29.3421C1.79051 29.3421 1.70099 29.3197 1.5667 29.2973C1.3205 29.7225 1.07431 30.1254 0.581916 30.2373C0.716204 30.8416 0.872874 31.4459 1.02954 32.0502C1.07431 32.0054 1.16383 31.9607 1.25336 31.8935C1.18621 32.0054 1.14145 32.1397 1.07431 32.2516C1.70099 34.3555 2.61862 36.3474 3.76007 38.1827L3.78245 38.1603C3.93912 38.026 3.62578 37.5336 4.16294 37.6232C4.2077 37.9589 4.2077 38.2499 3.91674 38.4737C3.93912 38.5184 3.9615 38.5632 4.00627 38.608C4.05103 38.5856 4.14056 38.5632 4.29723 38.5184C4.23008 38.5856 4.18532 38.6751 4.11817 38.7646C8.46016 45.3447 15.8236 49.7763 24.239 50.0225C24.2167 50.0001 24.1943 49.9553 24.1719 49.9329C24.3062 49.9777 24.4181 50.0001 24.5076 50.0225C24.6643 50.0225 24.8433 50.0225 25 50.0225C31.0654 50.0225 36.6159 47.8738 40.9355 44.2704C40.8013 44.2704 40.7565 44.2481 40.846 43.9571C41.0251 44.1138 41.0475 44.1138 41.0475 44.1585C44.1361 41.5847 46.5757 38.2499 48.12 34.4898C48.0081 34.5569 47.8962 34.6465 47.7619 34.736C47.7619 34.4226 47.829 34.2212 48.0976 34.1541C48.12 34.1541 48.1647 34.1988 48.2095 34.2436C48.2766 34.0869 48.3438 33.9079 48.4109 33.7512C48.3662 33.7512 48.3214 33.7512 48.2766 33.7512C48.3438 33.6617 48.4333 33.5721 48.5228 33.4379C48.6124 33.1917 48.7019 32.9455 48.769 32.6993C48.7467 32.6993 48.7243 32.7217 48.7019 32.744C48.7914 32.4531 48.8809 32.1621 48.9705 31.8488C48.9928 31.8488 49.0152 31.8488 49.0152 31.8712C49.06 31.6921 49.1048 31.5131 49.1719 31.334C49.1271 31.2669 49.1719 31.1773 49.239 31.0207C49.7091 29.0959 49.9776 27.0815 49.9776 25.0001C49.9776 18.1738 47.2471 11.9741 42.7932 7.47546C42.7708 7.47546 42.7261 7.49784 42.7037 7.52022C42.4575 7.40832 42.3903 7.22926 42.368 7.05021C40.4879 5.23732 38.3169 3.69301 35.9445 2.52918C35.9221 2.55156 35.8774 2.57394 35.855 2.6187C35.855 2.57394 35.855 2.52918 35.855 2.50679C34.2435 1.67868 32.4754 1.07439 30.6625 0.64914C30.5506 0.850572 30.3939 1.02962 30.1477 1.16391C30.0134 1.25344 29.8791 1.36534 29.7001 1.16391C29.9015 1.052 29.9015 0.693902 30.2596 0.761046C30.282 0.761046 30.3715 0.671521 30.3939 0.604377C30.1925 0.559614 29.9911 0.514851 29.7896 0.470088C29.6777 0.537233 29.521 0.626758 29.3196 0.738665C29.2077 0.581995 29.2077 0.470088 29.2301 0.380563C29.0958 0.358182 28.9391 0.3358 28.8048 0.313419C28.7825 0.425326 28.7825 0.581995 28.8048 0.828191C28.6034 0.98486 28.402 1.16391 28.1782 1.34296C28.1558 1.18629 28.0663 1.02962 28.0886 0.895335C28.1334 0.581995 28.1334 0.358182 28.0663 0.201512C27.0815 0.0896051 26.0519 0.0224609 25.0224 0.0224609C23.3214 0.0224609 21.6428 0.201512 20.0313 0.514851C20.0313 0.559614 20.0537 0.626758 20.0313 0.716284C19.8747 0.671521 19.7628 0.626758 19.6956 0.559614C18.8675 0.738665 18.0394 0.962479 17.2337 1.23106C17.1218 1.34296 17.0546 1.36534 16.9651 1.32058C7.0949 4.67779 0 14.0108 0 25.0001Z"
          fill="#00C968"
        />
        <path
          d="M6.02022 25.2235C5.97545 21.8439 6.82595 18.5091 8.57169 15.51L7.27357 14.749C4.54305 19.4939 3.80446 24.9997 5.23687 30.2817C6.6469 35.5637 10.0489 39.9728 14.7713 42.7257L15.5323 41.4276C11.2127 38.9433 8.10169 34.937 6.7588 30.125C6.7588 30.1698 6.73642 30.1698 6.6469 30.2146C6.46784 29.946 6.46784 30.0131 6.69166 29.9012C6.4007 28.7822 6.19927 27.6631 6.10974 26.544C6.08736 26.5664 6.06498 26.6112 6.06498 26.6112C6.08736 27.1707 5.63973 27.2602 5.25925 27.5064C5.12496 27.2378 5.01305 27.014 4.87877 26.7678C5.12496 26.7007 5.41592 26.6783 5.57259 26.5216C5.72926 26.3873 5.77402 26.0964 5.86355 25.8949C5.70688 25.7159 5.57259 25.5816 5.41592 25.4026C5.61735 25.2459 5.75164 25.134 5.88593 24.9997C5.90831 25.0668 5.93069 25.1116 6.02022 25.2235Z"
          fill="#00C968"
        />
        <path
          d="M25.2014 5.3269C25.0671 5.03594 24.9105 4.7226 24.7538 4.43164C24.6195 4.7226 24.4628 5.03594 24.3285 5.3269C23.9928 5.37166 23.6795 5.4388 23.3438 5.52833C23.6123 5.72976 23.8585 5.93119 24.1047 6.15501L23.9928 7.13979C24.2614 6.96074 24.5076 6.80407 24.7985 6.6474C25.0671 6.78169 25.3357 6.96074 25.6043 7.11741L25.4476 6.15501C25.6938 5.93119 25.94 5.70738 26.1862 5.50595C25.8729 5.39404 25.5371 5.37166 25.2014 5.3269Z"
          fill="#00C968"
        />
        <path
          d="M34.7135 40.5778L34.3554 39.6602L33.9078 40.4883C33.5945 40.4883 33.2811 40.4659 32.9678 40.4659L33.5721 41.2492C33.4825 41.5626 33.3706 41.8759 33.2363 42.1669C33.5497 42.0773 33.863 41.9431 34.1764 41.8312C34.4449 42.0326 34.7135 42.2116 35.0045 42.3907C34.9821 42.055 34.9597 41.7192 34.9373 41.4059C35.2059 41.2045 35.4521 40.9807 35.6983 40.7568C35.3402 40.7121 35.0269 40.6449 34.7135 40.5778Z"
          fill="#00C968"
        />
        <path
          d="M29.3871 43.6885C29.5886 43.9347 29.8124 44.2033 30.0362 44.4495C30.1033 44.1138 30.1705 43.8004 30.2152 43.4647L30.6629 43.2633L31.1105 43.0395C30.8867 42.9499 30.6852 42.838 30.4838 42.7485C30.4838 42.7709 30.4838 42.7709 30.4614 42.7933C30.3048 43.0395 30.0586 42.7709 29.4543 42.3233C29.1409 42.2561 28.85 42.1442 28.559 42.0547L28.9395 42.9499C28.7604 43.2185 28.5814 43.5095 28.4023 43.7781C28.7381 43.7557 29.0514 43.7109 29.3871 43.6885Z"
          fill="#00C968"
        />
        <path
          d="M30.1927 42.278L30.1032 41.6289L29.4541 42.3003C29.7898 42.2108 30.036 42.2108 30.1927 42.278Z"
          fill="#00C968"
        />
        <path
          d="M24.3061 44.3148C24.4404 44.6058 24.597 44.9191 24.7537 45.2101C24.888 44.9191 25.0447 44.6058 25.1789 44.3148C25.5147 44.2701 25.828 44.2029 26.1637 44.1134C25.8952 43.912 25.649 43.7105 25.4028 43.4867L25.5147 42.502C25.2461 42.681 24.9999 42.8377 24.7089 42.9943C24.4404 42.8601 24.1718 42.681 23.9032 42.5243L24.0599 43.4867C23.8137 43.7105 23.5675 43.9344 23.3213 44.1358C23.657 44.2253 23.9704 44.2477 24.3061 44.3148Z"
          fill="#00C968"
        />
        <path
          d="M29.5654 7.13982C29.7892 7.36364 30.013 7.58745 30.2368 7.81126L30.3263 6.82648C30.6173 6.66981 30.9082 6.51314 31.1992 6.37886C30.9082 6.22219 30.5949 6.11028 30.2816 5.97599C30.2144 5.66265 30.1473 5.32693 30.0801 4.99121C29.8563 5.23741 29.6549 5.50598 29.4535 5.77456C29.1177 5.75218 28.782 5.7298 28.4463 5.70742C28.6477 5.97599 28.8492 6.22219 29.0282 6.51314L28.6701 7.43078L29.5654 7.13982Z"
          fill="#00C968"
        />
        <path
          d="M19.4491 44.6062C19.673 44.36 19.8744 44.0914 20.0758 43.8228C20.4115 43.8452 20.7473 43.8676 21.083 43.89C20.8816 43.6214 20.6801 43.3752 20.5011 43.0843L20.8592 42.1666L19.9639 42.4576C19.7401 42.2338 19.5163 42.0099 19.2925 41.7861L19.203 42.7709C18.912 42.9276 18.621 43.0843 18.3301 43.2185C18.621 43.3752 18.9344 43.4871 19.2477 43.6214V43.6438C19.2925 43.5766 19.3372 43.5095 19.4044 43.4424C19.5834 43.599 19.7401 43.7333 19.9415 43.89C19.6506 43.9571 19.4715 44.0243 19.3372 44.0466C19.382 44.2705 19.4044 44.4271 19.4491 44.6062Z"
          fill="#00C968"
        />
        <path
          d="M38.5407 37.4884L37.9588 36.7051C37.8916 37.0184 37.8021 37.3094 37.7126 37.6227C37.4216 37.7122 37.0859 37.757 36.7949 37.8241L37.5783 38.4284C37.5559 38.7418 37.5335 39.0775 37.4887 39.4132C37.7797 39.2342 38.0483 39.0327 38.3169 38.8537C38.6302 38.9656 38.9435 39.0775 39.2569 39.1894C39.1673 38.8761 39.0554 38.5627 38.9435 38.2494C39.145 37.9808 39.3464 37.7122 39.5255 37.4437C39.1897 37.4437 38.854 37.466 38.5407 37.4884Z"
          fill="#00C968"
        />
        <path
          d="M38.6746 9.73629C37.6226 8.79627 36.4812 7.96816 35.2502 7.25195L34.4893 8.55007C38.876 11.0792 42.0094 15.175 43.3299 20.0765C43.4866 20.6584 43.6209 21.2627 43.7104 21.8446C43.7999 21.867 43.8894 21.9118 43.979 21.9789C43.9342 22.0684 43.9118 22.2027 43.8447 22.2027C43.8223 22.2027 43.7999 22.2027 43.7775 22.2251C43.8447 22.7175 43.9118 23.2099 43.9342 23.6799C43.979 23.7023 44.0237 23.747 44.0685 23.7694C44.0237 23.8142 43.979 23.8366 43.9566 23.8589C44.0685 25.6718 43.9118 27.4847 43.5089 29.2305C43.7328 29.1633 43.9342 29.0962 44.1804 29.32C44.2252 29.1633 44.2699 29.2081 43.9118 28.9619C43.6656 28.7828 43.6656 28.7828 43.9342 28.4471C44.1356 28.5143 44.158 28.8947 44.4937 28.8052C44.5161 28.8052 44.6056 29.0738 44.6056 29.0514C44.5161 29.32 44.2252 29.5662 44.5833 29.8348C44.3594 30.1033 44.158 30.2824 43.8223 30.3048C44.0461 30.7076 43.6209 30.7972 43.5313 31.0434C43.3299 31.0657 43.1285 31.0657 42.9494 31.0881C42.6585 31.9386 42.3004 32.7667 41.8975 33.5725C41.9646 33.6172 42.0318 33.662 42.0989 33.7067C41.8975 33.9306 41.8303 33.9977 41.6513 34.0201C41.5842 34.1544 41.517 34.2887 41.4275 34.4229L42.7256 35.1839C45.4561 30.4391 46.1947 24.9332 44.7623 19.6512C43.7328 15.7793 41.6289 12.3773 38.7193 9.75867C38.585 10.072 38.6746 10.4749 38.2717 10.6092C37.8465 10.7434 37.5779 10.4525 37.3093 10.0944C37.7793 10.0049 38.0703 9.40056 38.6746 9.73629Z"
          fill="#00C968"
        />
        <path
          d="M43.8227 30.3713C43.8899 29.6327 44.0018 29.4537 43.5765 29.5208C43.6884 29.8118 43.3079 30.1699 43.8227 30.3713Z"
          fill="#00C968"
        />
      </g>
      <defs>
        <clipPath id="clip0_2210_12464">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  iconRejectSigned: (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2210_12522)">
        <path
          d="M14.3242 8.95268C14.4809 8.97506 14.6376 9.01982 14.8166 9.06458L15.1747 9.98222L15.6223 9.15411C15.9357 9.15411 16.249 9.17649 16.5624 9.17649L15.9581 8.39314C15.9804 8.326 16.0028 8.25885 16.0252 8.19171C15.9581 8.16933 15.8909 8.14695 15.7566 8.10219C15.9581 7.90075 16.0476 7.81123 16.1595 7.85599C16.2043 7.74408 16.249 7.60979 16.2938 7.49789C15.9804 7.58741 15.6671 7.7217 15.3538 7.83361C15.1747 7.69932 14.9957 7.58741 14.8166 7.45312C14.8166 7.60979 14.839 7.78885 14.7718 7.99028C14.6823 7.78885 14.6152 7.63218 14.548 7.52027C14.5704 7.76646 14.5704 8.03504 14.5928 8.28124C14.5704 8.30362 14.5257 8.326 14.5033 8.37076C14.5928 8.37076 14.6823 8.37076 14.7942 8.37076C14.7942 8.66172 14.6823 8.84077 14.3242 8.95268Z"
          fill="#E50500"
        />
        <path
          d="M13.8545 8.86288C13.8993 8.86288 13.944 8.88527 13.9888 8.88527C13.9888 8.8405 13.9888 8.79574 13.9888 8.75098C13.9216 8.79574 13.8993 8.81812 13.8545 8.86288Z"
          fill="#E50500"
        />
        <path
          d="M20.1208 5.93097C19.9194 5.68477 19.6956 5.43858 19.4718 5.19238C19.4046 5.5281 19.3375 5.84144 19.2927 6.17716L18.8451 6.3786L18.3975 6.60241C18.7108 6.7367 19.0018 6.87099 19.2927 7.02766L19.427 7.99006L20.0761 7.31861C20.3894 7.38576 20.6804 7.49766 20.9713 7.58719L20.5908 6.69193C20.7699 6.42336 20.9489 6.1324 21.128 5.86382C20.7923 5.86382 20.4565 5.90859 20.1208 5.93097Z"
          fill="#E50500"
        />
        <path
          d="M10.9897 12.1309L11.5716 12.9142C11.6387 12.6009 11.7283 12.3099 11.8178 11.9966C12.1087 11.907 12.4445 11.8623 12.7354 11.7951L11.9521 11.1908C11.9744 10.8775 11.9968 10.5418 12.0416 10.2061C11.7506 10.3851 11.4821 10.5865 11.2135 10.7656C10.9001 10.6537 10.5868 10.5418 10.2735 10.4299C10.363 10.7432 10.4749 11.0565 10.5868 11.3699C10.3854 11.6385 10.1839 11.907 10.0049 12.1756C10.3406 12.1756 10.6539 12.1532 10.9897 12.1309Z"
          fill="#E50500"
        />
        <path
          d="M18.1292 35.8776C18.1515 35.6538 18.1292 35.5867 17.9053 35.4748C17.5696 35.3181 17.9501 35.139 18.0396 34.9824C17.9501 34.8929 17.9053 34.8257 17.7934 34.6914C18.0396 34.5795 18.2635 34.4676 18.5096 34.3333C18.6216 34.7138 18.7111 35.0271 18.8006 35.3629C19.2706 35.3629 19.4273 35.721 19.6287 36.1462C19.2259 36.0567 19.3154 35.9672 19.1587 36.4595L22.8293 38.5858C22.8069 38.4291 22.8516 38.2948 23.0083 38.2724C23.0978 38.2501 23.2097 38.2948 23.2769 38.3396L25.1122 35.1614C25.0674 35.1614 25.045 35.1838 25.0002 35.1838C24.9555 35.1838 24.9107 35.0719 24.9107 35.0495C24.9331 35.0048 25.0002 34.96 25.1122 34.8928C25.1345 34.96 25.1569 35.0048 25.1793 35.0495L25.9403 33.7514C25.8507 33.729 25.7388 33.7066 25.5598 33.6395C25.7388 33.5723 25.9179 33.4828 26.0969 33.5052L26.6788 32.4757C26.5893 32.5204 26.4998 32.5652 26.3655 32.5876C26.1193 31.9161 26.3431 31.5804 27.0817 31.5804C27.0593 31.6923 27.0369 31.7818 27.0146 31.8937L30.797 25.3584C30.7523 25.4031 30.7299 25.4255 30.6627 25.4703C30.6851 25.1346 30.7075 24.9331 30.9985 25.0003L33.4828 20.7031C33.4604 20.6583 33.4156 20.5688 33.3709 20.4792C33.438 20.4792 33.5276 20.4792 33.5947 20.5016L37.1533 14.3244L30.5508 10.5195L20.3002 28.2903L13.7872 24.5303L9.95996 31.1552L18.1292 35.8776Z"
          fill="#E50500"
        />
        <path
          d="M0 25.0001C0 25.0896 0 25.1567 0 25.2463C0.0447628 25.2239 0.0895255 25.2015 0.179051 25.2015C0.201432 25.2015 0.290958 25.3134 0.268577 25.3134C0.201432 25.4029 0.15667 25.5148 0.0671442 25.5596C0.0447628 25.5596 0.0223814 25.582 0 25.582C0.0223814 26.9025 0.15667 28.2006 0.402865 29.4764C0.470009 29.4316 0.514772 29.3644 0.559535 29.2749C0.626679 29.1406 0.895255 29.0959 1.09669 29.0063C1.16383 28.6035 0.738586 28.7154 0.581916 28.5363C0.49239 28.2006 0.425246 27.8649 0.290958 27.3725C0.760967 27.7082 0.984781 28.1335 1.38765 28.3349C1.49955 28.3797 1.61146 28.4468 1.72337 28.514C1.70099 28.2901 1.65622 28.0887 1.63384 27.8649C1.41003 27.932 1.20859 27.9768 1.00716 27.753C0.581916 27.2606 0.783348 26.7906 0.80573 26.6339C1.09669 26.522 1.3205 26.4772 1.49955 26.5444C1.47717 26.3206 1.47717 26.0968 1.45479 25.8506C1.41003 25.8506 1.38765 25.8282 1.34288 25.8282C1.09669 25.7163 1.25336 25.582 1.36526 25.4029C1.38765 25.4253 1.41003 25.4477 1.43241 25.4701C1.38765 23.6124 1.5667 21.7772 1.96956 20.009C1.79051 19.8524 1.74575 19.7181 1.79051 19.5614C1.83527 19.4271 1.9248 19.36 2.12623 19.3824C3.9615 11.9517 9.35542 5.61781 16.8979 2.8649C16.8308 2.79775 16.7637 2.73061 16.6741 2.66346C16.8532 2.6187 16.9651 2.57394 17.1441 2.52918C17.1218 2.6187 17.1218 2.70823 17.1218 2.79775C17.547 2.64108 17.9946 2.50679 18.4423 2.37251C18.3751 2.17107 18.2856 1.94726 18.1961 1.67868C18.4199 1.74583 19.3151 1.85773 19.0913 2.19345C22.5381 1.2982 26.0295 1.20867 29.3196 1.83535C29.2972 1.81297 29.2972 1.81297 29.2748 1.79059C29.7225 1.67868 29.7672 1.6563 29.9687 1.96964C30.5058 2.08155 31.0206 2.21584 31.5354 2.37251C31.5577 2.35012 31.5801 2.30536 31.6249 2.2606C31.6473 2.32774 31.6697 2.37251 31.692 2.41727C34.333 3.20062 36.795 4.43159 39.0107 6.06543C39.0107 5.99829 39.0107 5.90876 38.9884 5.75209C39.4136 5.95353 39.3689 5.81924 39.2569 6.2221C39.2346 6.2221 39.2122 6.19972 39.1898 6.19972C43.2408 9.24359 46.3518 13.6303 47.7619 18.89C51.1191 31.4235 43.6437 44.3824 31.1101 47.7396C29.8568 48.0753 28.6034 48.2991 27.3277 48.4334C27.4172 48.5677 27.5515 48.6796 27.5739 48.8139C27.6634 49.3734 27.2381 49.4182 26.6338 49.6867C26.88 49.2167 27.0591 48.8362 27.2605 48.4334C26.0072 48.5453 24.7314 48.5677 23.5005 48.5005C23.6124 48.6348 23.6571 48.702 23.5676 48.9929C23.5676 49.0153 23.3885 49.0153 23.3662 48.9929C23.2319 48.7691 23.3214 48.6124 23.3885 48.5005C23.12 48.4781 22.8514 48.4558 22.5828 48.4334V48.4558C22.4933 48.4558 22.4261 48.4334 22.3814 48.411C20.9937 48.2543 19.6061 47.9634 18.2856 47.5605C18.5765 47.9186 18.487 48.0305 17.9499 48.3439C17.9722 48.1648 18.0618 47.9634 18.017 47.8738C17.9275 47.7172 17.9499 47.6053 18.017 47.4934C16.2936 46.9562 14.6374 46.2176 13.0931 45.3C12.8022 45.3 12.735 45.3 12.6679 45.0538C12.4888 44.9419 12.3098 44.83 12.1531 44.7181C12.1083 44.7628 12.1083 44.7405 11.9964 44.6733C11.9964 44.6509 12.0188 44.6509 12.0188 44.6285C7.38586 41.5623 3.82722 36.8622 2.2829 31.1102C2.12623 30.5283 1.99194 29.924 1.88004 29.3421C1.79051 29.3421 1.70099 29.3197 1.5667 29.2973C1.3205 29.7225 1.07431 30.1254 0.581916 30.2373C0.716204 30.8416 0.872874 31.4459 1.02954 32.0502C1.07431 32.0054 1.16383 31.9607 1.25336 31.8935C1.18621 32.0054 1.14145 32.1397 1.07431 32.2516C1.70099 34.3555 2.61862 36.3474 3.76007 38.1827L3.78245 38.1603C3.93912 38.026 3.62578 37.5336 4.16294 37.6232C4.2077 37.9589 4.2077 38.2499 3.91674 38.4737C3.93912 38.5184 3.9615 38.5632 4.00627 38.608C4.05103 38.5856 4.14056 38.5632 4.29723 38.5184C4.23008 38.5856 4.18532 38.6751 4.11817 38.7646C8.46016 45.3447 15.8236 49.7763 24.239 50.0225C24.2167 50.0001 24.1943 49.9553 24.1719 49.9329C24.3062 49.9777 24.4181 50.0001 24.5076 50.0225C24.6643 50.0225 24.8433 50.0225 25 50.0225C31.0654 50.0225 36.6159 47.8738 40.9355 44.2704C40.8013 44.2704 40.7565 44.2481 40.846 43.9571C41.0251 44.1138 41.0475 44.1138 41.0475 44.1585C44.1361 41.5847 46.5757 38.2499 48.12 34.4898C48.0081 34.5569 47.8962 34.6465 47.7619 34.736C47.7619 34.4226 47.829 34.2212 48.0976 34.1541C48.12 34.1541 48.1647 34.1988 48.2095 34.2436C48.2766 34.0869 48.3438 33.9079 48.4109 33.7512C48.3662 33.7512 48.3214 33.7512 48.2766 33.7512C48.3438 33.6617 48.4333 33.5721 48.5228 33.4379C48.6124 33.1917 48.7019 32.9455 48.769 32.6993C48.7467 32.6993 48.7243 32.7217 48.7019 32.744C48.7914 32.4531 48.8809 32.1621 48.9705 31.8488C48.9928 31.8488 49.0152 31.8488 49.0152 31.8712C49.06 31.6921 49.1048 31.5131 49.1719 31.334C49.1271 31.2669 49.1719 31.1773 49.239 31.0207C49.7091 29.0959 49.9776 27.0815 49.9776 25.0001C49.9776 18.1738 47.2471 11.9741 42.7932 7.47546C42.7708 7.47546 42.7261 7.49784 42.7037 7.52022C42.4575 7.40832 42.3903 7.22926 42.368 7.05021C40.4879 5.23732 38.3169 3.69301 35.9445 2.52918C35.9221 2.55156 35.8774 2.57394 35.855 2.6187C35.855 2.57394 35.855 2.52918 35.855 2.50679C34.2435 1.67868 32.4754 1.07439 30.6625 0.64914C30.5506 0.850572 30.3939 1.02962 30.1477 1.16391C30.0134 1.25344 29.8791 1.36534 29.7001 1.16391C29.9015 1.052 29.9015 0.693902 30.2596 0.761046C30.282 0.761046 30.3715 0.671521 30.3939 0.604377C30.1925 0.559614 29.9911 0.514851 29.7896 0.470088C29.6777 0.537233 29.521 0.626758 29.3196 0.738665C29.2077 0.581995 29.2077 0.470088 29.2301 0.380563C29.0958 0.358182 28.9391 0.3358 28.8048 0.313419C28.7825 0.425326 28.7825 0.581995 28.8048 0.828191C28.6034 0.98486 28.402 1.16391 28.1782 1.34296C28.1558 1.18629 28.0663 1.02962 28.0886 0.895335C28.1334 0.581995 28.1334 0.358182 28.0663 0.201512C27.0815 0.0896051 26.0519 0.0224609 25.0224 0.0224609C23.3214 0.0224609 21.6428 0.201512 20.0313 0.514851C20.0313 0.559614 20.0537 0.626758 20.0313 0.716284C19.8747 0.671521 19.7628 0.626758 19.6956 0.559614C18.8675 0.738665 18.0394 0.962479 17.2337 1.23106C17.1218 1.34296 17.0546 1.36534 16.9651 1.32058C7.0949 4.67779 0 14.0108 0 25.0001Z"
          fill="#E50500"
        />
        <path
          d="M6.02022 25.2235C5.97545 21.8439 6.82595 18.5091 8.57169 15.51L7.27357 14.749C4.54305 19.4939 3.80446 24.9997 5.23687 30.2817C6.6469 35.5637 10.0489 39.9728 14.7713 42.7257L15.5323 41.4276C11.2127 38.9433 8.10169 34.937 6.7588 30.125C6.7588 30.1698 6.73642 30.1698 6.6469 30.2146C6.46784 29.946 6.46784 30.0131 6.69166 29.9012C6.4007 28.7822 6.19927 27.6631 6.10974 26.544C6.08736 26.5664 6.06498 26.6112 6.06498 26.6112C6.08736 27.1707 5.63973 27.2602 5.25925 27.5064C5.12496 27.2378 5.01305 27.014 4.87877 26.7678C5.12496 26.7007 5.41592 26.6783 5.57259 26.5216C5.72926 26.3873 5.77402 26.0964 5.86355 25.8949C5.70688 25.7159 5.57259 25.5816 5.41592 25.4026C5.61735 25.2459 5.75164 25.134 5.88593 24.9997C5.90831 25.0668 5.93069 25.1116 6.02022 25.2235Z"
          fill="#E50500"
        />
        <path
          d="M25.2014 5.3269C25.0671 5.03594 24.9105 4.7226 24.7538 4.43164C24.6195 4.7226 24.4628 5.03594 24.3285 5.3269C23.9928 5.37166 23.6795 5.4388 23.3438 5.52833C23.6123 5.72976 23.8585 5.93119 24.1047 6.15501L23.9928 7.13979C24.2614 6.96074 24.5076 6.80407 24.7985 6.6474C25.0671 6.78169 25.3357 6.96074 25.6043 7.11741L25.4476 6.15501C25.6938 5.93119 25.94 5.70738 26.1862 5.50595C25.8729 5.39404 25.5371 5.37166 25.2014 5.3269Z"
          fill="#E50500"
        />
        <path
          d="M34.7135 40.5778L34.3554 39.6602L33.9078 40.4883C33.5945 40.4883 33.2811 40.4659 32.9678 40.4659L33.5721 41.2492C33.4825 41.5626 33.3706 41.8759 33.2363 42.1669C33.5497 42.0773 33.863 41.9431 34.1764 41.8312C34.4449 42.0326 34.7135 42.2116 35.0045 42.3907C34.9821 42.055 34.9597 41.7192 34.9373 41.4059C35.2059 41.2045 35.4521 40.9807 35.6983 40.7568C35.3402 40.7121 35.0269 40.6449 34.7135 40.5778Z"
          fill="#E50500"
        />
        <path
          d="M29.3871 43.6885C29.5886 43.9347 29.8124 44.2033 30.0362 44.4495C30.1033 44.1138 30.1705 43.8004 30.2152 43.4647L30.6629 43.2633L31.1105 43.0395C30.8867 42.9499 30.6852 42.838 30.4838 42.7485C30.4838 42.7709 30.4838 42.7709 30.4614 42.7933C30.3048 43.0395 30.0586 42.7709 29.4543 42.3233C29.1409 42.2561 28.85 42.1442 28.559 42.0547L28.9395 42.9499C28.7604 43.2185 28.5814 43.5095 28.4023 43.7781C28.7381 43.7557 29.0514 43.7109 29.3871 43.6885Z"
          fill="#E50500"
        />
        <path
          d="M30.1927 42.278L30.1032 41.6289L29.4541 42.3003C29.7898 42.2108 30.036 42.2108 30.1927 42.278Z"
          fill="#E50500"
        />
        <path
          d="M24.3061 44.3148C24.4404 44.6058 24.597 44.9191 24.7537 45.2101C24.888 44.9191 25.0447 44.6058 25.1789 44.3148C25.5147 44.2701 25.828 44.2029 26.1637 44.1134C25.8952 43.912 25.649 43.7105 25.4028 43.4867L25.5147 42.502C25.2461 42.681 24.9999 42.8377 24.7089 42.9943C24.4404 42.8601 24.1718 42.681 23.9032 42.5243L24.0599 43.4867C23.8137 43.7105 23.5675 43.9344 23.3213 44.1358C23.657 44.2253 23.9704 44.2477 24.3061 44.3148Z"
          fill="#E50500"
        />
        <path
          d="M29.5654 7.13982C29.7892 7.36364 30.013 7.58745 30.2368 7.81126L30.3263 6.82648C30.6173 6.66981 30.9082 6.51314 31.1992 6.37886C30.9082 6.22219 30.5949 6.11028 30.2816 5.97599C30.2144 5.66265 30.1473 5.32693 30.0801 4.99121C29.8563 5.23741 29.6549 5.50598 29.4535 5.77456C29.1177 5.75218 28.782 5.7298 28.4463 5.70742C28.6477 5.97599 28.8492 6.22219 29.0282 6.51314L28.6701 7.43078L29.5654 7.13982Z"
          fill="#E50500"
        />
        <path
          d="M19.4491 44.6062C19.673 44.36 19.8744 44.0914 20.0758 43.8228C20.4115 43.8452 20.7473 43.8676 21.083 43.89C20.8816 43.6214 20.6801 43.3752 20.5011 43.0843L20.8592 42.1666L19.9639 42.4576C19.7401 42.2338 19.5163 42.0099 19.2925 41.7861L19.203 42.7709C18.912 42.9276 18.621 43.0843 18.3301 43.2185C18.621 43.3752 18.9344 43.4871 19.2477 43.6214V43.6438C19.2925 43.5766 19.3372 43.5095 19.4044 43.4424C19.5834 43.599 19.7401 43.7333 19.9415 43.89C19.6506 43.9571 19.4715 44.0243 19.3372 44.0466C19.382 44.2705 19.4044 44.4271 19.4491 44.6062Z"
          fill="#E50500"
        />
        <path
          d="M38.5407 37.4884L37.9588 36.7051C37.8916 37.0184 37.8021 37.3094 37.7126 37.6227C37.4216 37.7122 37.0859 37.757 36.7949 37.8241L37.5783 38.4284C37.5559 38.7418 37.5335 39.0775 37.4887 39.4132C37.7797 39.2342 38.0483 39.0327 38.3169 38.8537C38.6302 38.9656 38.9435 39.0775 39.2569 39.1894C39.1673 38.8761 39.0554 38.5627 38.9435 38.2494C39.145 37.9808 39.3464 37.7122 39.5255 37.4437C39.1897 37.4437 38.854 37.466 38.5407 37.4884Z"
          fill="#E50500"
        />
        <path
          d="M38.6746 9.73629C37.6226 8.79627 36.4812 7.96816 35.2502 7.25195L34.4893 8.55007C38.876 11.0792 42.0094 15.175 43.3299 20.0765C43.4866 20.6584 43.6209 21.2627 43.7104 21.8446C43.7999 21.867 43.8894 21.9118 43.979 21.9789C43.9342 22.0684 43.9118 22.2027 43.8447 22.2027C43.8223 22.2027 43.7999 22.2027 43.7775 22.2251C43.8447 22.7175 43.9118 23.2099 43.9342 23.6799C43.979 23.7023 44.0237 23.747 44.0685 23.7694C44.0237 23.8142 43.979 23.8366 43.9566 23.8589C44.0685 25.6718 43.9118 27.4847 43.5089 29.2305C43.7328 29.1633 43.9342 29.0962 44.1804 29.32C44.2252 29.1633 44.2699 29.2081 43.9118 28.9619C43.6656 28.7828 43.6656 28.7828 43.9342 28.4471C44.1356 28.5143 44.158 28.8947 44.4937 28.8052C44.5161 28.8052 44.6056 29.0738 44.6056 29.0514C44.5161 29.32 44.2252 29.5662 44.5833 29.8348C44.3594 30.1033 44.158 30.2824 43.8223 30.3048C44.0461 30.7076 43.6209 30.7972 43.5313 31.0434C43.3299 31.0657 43.1285 31.0657 42.9494 31.0881C42.6585 31.9386 42.3004 32.7667 41.8975 33.5725C41.9646 33.6172 42.0318 33.662 42.0989 33.7067C41.8975 33.9306 41.8303 33.9977 41.6513 34.0201C41.5842 34.1544 41.517 34.2887 41.4275 34.4229L42.7256 35.1839C45.4561 30.4391 46.1947 24.9332 44.7623 19.6512C43.7328 15.7793 41.6289 12.3773 38.7193 9.75867C38.585 10.072 38.6746 10.4749 38.2717 10.6092C37.8465 10.7434 37.5779 10.4525 37.3093 10.0944C37.7793 10.0049 38.0703 9.40056 38.6746 9.73629Z"
          fill="#E50500"
        />
        <path
          d="M43.8227 30.3713C43.8899 29.6327 44.0018 29.4537 43.5765 29.5208C43.6884 29.8118 43.3079 30.1699 43.8227 30.3713Z"
          fill="#E50500"
        />
      </g>
      <defs>
        <clipPath id="clip0_2210_12522">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  signSuccess: (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.0005 73.9005L36.1005 60.0005L31.3672 64.7005L50.0005 83.3338L90.0005 43.3338L85.3005 38.6338L50.0005 73.9005Z"
        fill="#0D99FF"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#0D99FF" strokeDasharray="5 5" />
    </svg>
  ),
  hidePassLogin: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00033 4.00003C10.527 4.00003 12.7803 5.42003 13.8803 7.6667C13.487 8.48003 12.9337 9.18003 12.2737 9.7467L13.2137 10.6867C14.1403 9.8667 14.8737 8.84003 15.3337 7.6667C14.1803 4.74003 11.3337 2.6667 8.00033 2.6667C7.15366 2.6667 6.34032 2.80003 5.57366 3.0467L6.67366 4.1467C7.10699 4.06003 7.54699 4.00003 8.00033 4.00003ZM7.28699 4.76003L8.66699 6.14003C9.04699 6.3067 9.35366 6.61336 9.52032 6.99336L10.9003 8.37336C10.9537 8.1467 10.9937 7.9067 10.9937 7.66003C11.0003 6.0067 9.65366 4.6667 8.00033 4.6667C7.75366 4.6667 7.52033 4.70003 7.28699 4.76003ZM1.34033 2.58003L3.12699 4.3667C2.04033 5.22003 1.18033 6.35336 0.666992 7.6667C1.82033 10.5934 4.66699 12.6667 8.00033 12.6667C9.01366 12.6667 9.98699 12.4734 10.8803 12.12L13.1603 14.4L14.1003 13.46L2.28033 1.63336L1.34033 2.58003ZM6.34033 7.58003L8.08033 9.32003C8.05366 9.32669 8.02699 9.33336 8.00033 9.33336C7.08033 9.33336 6.33366 8.5867 6.33366 7.6667C6.33366 7.63336 6.34033 7.61336 6.34033 7.58003ZM4.07366 5.31336L5.24033 6.48003C5.08699 6.8467 5.00033 7.2467 5.00033 7.6667C5.00033 9.32003 6.34699 10.6667 8.00033 10.6667C8.42033 10.6667 8.82032 10.58 9.18033 10.4267L9.83366 11.08C9.24699 11.24 8.63366 11.3334 8.00033 11.3334C5.47366 11.3334 3.22033 9.91336 2.12033 7.6667C2.58699 6.71336 3.26699 5.92669 4.07366 5.31336Z"
        fill="#323232"
      />
    </svg>
  ),
  checkDisabled: (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5" clipPath="url(#clip0_2178_12364)">
        <path
          d="M20.0547 12.5339C20.274 12.5653 20.4934 12.6279 20.744 12.6906L21.2454 13.9753L21.8721 12.816C22.3107 12.816 22.7494 12.8473 23.1881 12.8473L22.3421 11.7506C22.3734 11.6566 22.4047 11.5626 22.4361 11.4686C22.3421 11.4373 22.2481 11.4059 22.0601 11.3433C22.3421 11.0612 22.4674 10.9359 22.6241 10.9986C22.6867 10.8419 22.7494 10.6539 22.8121 10.4972C22.3734 10.6226 21.9347 10.8106 21.496 10.9672C21.2454 10.7792 20.9947 10.6226 20.744 10.4346C20.744 10.6539 20.7754 10.9046 20.6814 11.1866C20.556 10.9046 20.462 10.6852 20.368 10.5286C20.3994 10.8732 20.3994 11.2493 20.4307 11.5939C20.3994 11.6253 20.3367 11.6566 20.3054 11.7193C20.4307 11.7193 20.556 11.7193 20.7127 11.7193C20.7127 12.1266 20.556 12.3773 20.0547 12.5339Z"
          fill="white"
        />
        <path
          d="M19.3965 12.4086C19.4592 12.4086 19.5218 12.44 19.5845 12.44C19.5845 12.3773 19.5845 12.3146 19.5845 12.252C19.4905 12.3146 19.4592 12.346 19.3965 12.4086Z"
          fill="white"
        />
        <path
          d="M28.1686 8.30355C27.8866 7.95888 27.5732 7.6142 27.2599 7.26953C27.1659 7.73954 27.0719 8.17822 27.0092 8.64822L26.3825 8.93023L25.7559 9.24357C26.1945 9.43157 26.6019 9.61958 27.0092 9.83891L27.1972 11.1863L28.1059 10.2463C28.5446 10.3403 28.9519 10.4969 29.3593 10.6223L28.8266 9.3689C29.0773 8.9929 29.3279 8.58556 29.5786 8.20955C29.1086 8.20955 28.6386 8.27222 28.1686 8.30355Z"
          fill="white"
        />
        <path
          d="M15.3846 16.9828L16.1992 18.0795C16.2932 17.6408 16.4186 17.2335 16.5439 16.7948C16.9513 16.6695 17.4213 16.6068 17.8286 16.5128L16.7319 15.6668C16.7633 15.2281 16.7946 14.7581 16.8573 14.2881C16.4499 14.5388 16.0739 14.8208 15.6979 15.0714C15.2592 14.9148 14.8205 14.7581 14.3819 14.6014C14.5072 15.0401 14.6639 15.4788 14.8205 15.9175C14.5385 16.2935 14.2565 16.6695 14.0059 17.0455C14.4759 17.0455 14.9145 17.0141 15.3846 16.9828Z"
          fill="white"
        />
        <path
          d="M25.3802 50.2279C25.4116 49.9146 25.3802 49.8206 25.0669 49.6639C24.5969 49.4446 25.1296 49.1939 25.2549 48.9746C25.1296 48.8492 25.0669 48.7552 24.9102 48.5672C25.2549 48.4105 25.5682 48.2539 25.9129 48.0659C26.0696 48.5985 26.1949 49.0372 26.3203 49.5072C26.9783 49.5072 27.1976 50.0086 27.4796 50.6039C26.9156 50.4786 27.0409 50.3532 26.8216 51.0426L31.9604 54.0193C31.929 53.8 31.9917 53.612 32.211 53.5806C32.3364 53.5493 32.493 53.612 32.587 53.6746L35.1564 49.2252C35.0938 49.2252 35.0624 49.2566 34.9998 49.2566C34.9371 49.2566 34.8744 49.0999 34.8744 49.0686C34.9058 49.0059 34.9998 48.9432 35.1564 48.8492C35.1878 48.9432 35.2191 49.0059 35.2504 49.0686L36.3158 47.2512C36.1904 47.2199 36.0338 47.1885 35.7831 47.0945C36.0338 47.0005 36.2844 46.8752 36.5351 46.9065L37.3498 45.4652C37.2245 45.5278 37.0991 45.5905 36.9111 45.6218C36.5665 44.6818 36.8798 44.2118 37.9138 44.2118C37.8825 44.3685 37.8511 44.4938 37.8198 44.6505L43.1152 35.501C43.0526 35.5636 43.0212 35.595 42.9272 35.6576C42.9586 35.1876 42.9899 34.9056 43.3972 34.9996L46.8753 28.9835C46.844 28.9208 46.7813 28.7955 46.7186 28.6702C46.8126 28.6702 46.938 28.6702 47.032 28.7015L52.0141 20.0533L42.7706 14.7266L28.4196 39.6057L19.3015 34.3416L13.9434 43.6164L25.3802 50.2279Z"
          fill="white"
        />
        <path
          d="M0 34.9999C0 35.1252 0 35.2192 0 35.3446C0.0626679 35.3133 0.125336 35.2819 0.250671 35.2819C0.282005 35.2819 0.407341 35.4386 0.376007 35.4386C0.282005 35.5639 0.219338 35.7206 0.0940018 35.7833C0.0626679 35.7833 0.0313339 35.8146 0 35.8146C0.0313339 37.6633 0.219338 39.4807 0.564011 41.2667C0.658013 41.204 0.72068 41.11 0.783348 40.9847C0.87735 40.7967 1.25336 40.734 1.53536 40.6087C1.62936 40.0447 1.03402 40.2013 0.814682 39.9507C0.689346 39.4807 0.595345 39.0107 0.407341 38.3213C1.06535 38.7913 1.37869 39.3867 1.9427 39.6687C2.09937 39.7313 2.25604 39.8253 2.41271 39.9193C2.38138 39.606 2.31871 39.324 2.28738 39.0107C1.97404 39.1047 1.69203 39.1673 1.41003 38.854C0.814682 38.1646 1.09669 37.5066 1.12802 37.2873C1.53536 37.1306 1.8487 37.068 2.09937 37.162C2.06804 36.8486 2.06804 36.5353 2.03671 36.1906C1.97404 36.1906 1.9427 36.1593 1.88004 36.1593C1.53536 36.0026 1.7547 35.8146 1.91137 35.5639C1.9427 35.5953 1.97404 35.6266 2.00537 35.6579C1.9427 33.0572 2.19338 30.4878 2.75739 28.0124C2.50671 27.7931 2.44405 27.6051 2.50671 27.3858C2.56938 27.1978 2.69472 27.1038 2.97672 27.1351C5.54611 16.7322 13.0976 7.86473 23.6571 4.01066C23.5631 3.91666 23.4691 3.82265 23.3438 3.72865C23.5945 3.66599 23.7511 3.60332 24.0018 3.54065C23.9705 3.66599 23.9705 3.79132 23.9705 3.91666C24.5658 3.69732 25.1925 3.50932 25.8192 3.32131C25.7252 3.03931 25.5998 2.72597 25.4745 2.34996C25.7878 2.44396 27.0412 2.60063 26.7278 3.07064C31.5533 1.81728 36.4414 1.69195 41.0475 2.5693C41.0161 2.53796 41.0161 2.53796 40.9848 2.50663C41.6115 2.34996 41.6741 2.31863 41.9561 2.7573C42.7081 2.91397 43.4288 3.10197 44.1495 3.32131C44.1808 3.28998 44.2122 3.22731 44.2748 3.16464C44.3062 3.25864 44.3375 3.32131 44.3689 3.38398C48.0663 4.48067 51.513 6.20403 54.615 8.49141C54.615 8.39741 54.615 8.27207 54.5837 8.05274C55.1791 8.33474 55.1164 8.14674 54.9597 8.71075C54.9284 8.71075 54.8971 8.67941 54.8657 8.67941C60.5372 12.9408 64.8926 19.0823 66.8666 26.4458C71.5667 43.9927 61.1012 62.1351 43.5542 66.8352C41.7995 67.3052 40.0448 67.6185 38.2587 67.8065C38.3841 67.9945 38.5721 68.1512 38.6034 68.3392C38.7287 69.1226 38.1334 69.1852 37.2874 69.5612C37.6321 68.9032 37.8827 68.3705 38.1647 67.8065C36.41 67.9632 34.624 67.9945 32.9006 67.9005C33.0573 68.0885 33.12 68.1825 32.9946 68.5899C32.9946 68.6212 32.744 68.6212 32.7126 68.5899C32.5246 68.2765 32.65 68.0572 32.744 67.9005C32.368 67.8692 31.9919 67.8379 31.6159 67.8065V67.8379C31.4906 67.8379 31.3966 67.8065 31.3339 67.7752C29.3912 67.5559 27.4485 67.1485 25.5998 66.5845C26.0072 67.0859 25.8818 67.2425 25.1298 67.6812C25.1611 67.4305 25.2865 67.1485 25.2238 67.0232C25.0985 66.8038 25.1298 66.6472 25.2238 66.4905C22.8111 65.7385 20.4924 64.7045 18.3304 63.4198C17.923 63.4198 17.829 63.4198 17.735 63.0751C17.4843 62.9184 17.2337 62.7618 17.0143 62.6051C16.9517 62.6678 16.9517 62.6364 16.795 62.5424C16.795 62.5111 16.8263 62.5111 16.8263 62.4798C10.3402 58.187 5.3581 51.6069 3.19606 43.5541C2.97672 42.7394 2.78872 41.8934 2.63205 41.0787C2.50671 41.0787 2.38138 41.0474 2.19338 41.016C1.8487 41.6114 1.50403 42.1754 0.814682 42.3321C1.00269 43.1781 1.22202 44.0241 1.44136 44.8701C1.50403 44.8074 1.62936 44.7448 1.7547 44.6508C1.6607 44.8074 1.59803 44.9954 1.50403 45.1521C2.38138 48.0975 3.66607 50.8862 5.2641 53.4556L5.29543 53.4243C5.51477 53.2363 5.0761 52.5469 5.82811 52.6722C5.89078 53.1423 5.89078 53.5496 5.48344 53.8629C5.51477 53.9256 5.54611 53.9883 5.60877 54.0509C5.67144 54.0196 5.79678 53.9883 6.01612 53.9256C5.92211 54.0196 5.85945 54.1449 5.76544 54.2703C11.8442 63.4824 22.1531 69.6866 33.9347 70.0312C33.9033 69.9999 33.872 69.9372 33.8406 69.9059C34.0287 69.9686 34.1853 69.9999 34.3107 70.0312C34.53 70.0312 34.7807 70.0312 35 70.0312C43.4915 70.0312 51.2623 67.0232 57.3098 61.9784C57.1218 61.9784 57.0591 61.9471 57.1844 61.5397C57.4351 61.7591 57.4664 61.7591 57.4664 61.8218C61.7905 58.2183 65.2059 53.5496 67.368 48.2855C67.2113 48.3795 67.0546 48.5048 66.8666 48.6302C66.8666 48.1915 66.9606 47.9095 67.3366 47.8155C67.368 47.8155 67.4306 47.8782 67.4933 47.9408C67.5873 47.7215 67.6813 47.4708 67.7753 47.2515C67.7126 47.2515 67.65 47.2515 67.5873 47.2515C67.6813 47.1261 67.8066 47.0008 67.932 46.8128C68.0573 46.4681 68.1826 46.1235 68.2766 45.7788C68.2453 45.7788 68.214 45.8101 68.1826 45.8414C68.308 45.4341 68.4333 45.0268 68.5586 44.5881C68.59 44.5881 68.6213 44.5881 68.6213 44.6194C68.684 44.3688 68.7466 44.1181 68.8406 43.8674C68.778 43.7734 68.8407 43.6481 68.9347 43.4287C69.5927 40.734 69.9687 37.914 69.9687 34.9999C69.9687 25.4431 66.1459 16.7636 59.9105 10.4654C59.8791 10.4654 59.8165 10.4968 59.7851 10.5281C59.4405 10.3714 59.3465 10.1208 59.3151 9.8701C56.6831 7.33205 53.6437 5.17001 50.3223 3.54065C50.291 3.57198 50.2283 3.60332 50.197 3.66599C50.197 3.60332 50.197 3.54065 50.197 3.50932C47.9409 2.34996 45.4655 1.50394 42.9275 0.9086C42.7708 1.19061 42.5515 1.44128 42.2068 1.62928C42.0188 1.75462 41.8308 1.91129 41.5801 1.62928C41.8621 1.47261 41.8621 0.971268 42.3635 1.06527C42.3948 1.06527 42.5201 0.939934 42.5515 0.845932C42.2695 0.783264 41.9875 0.720596 41.7055 0.657928C41.5488 0.75193 41.3295 0.877266 41.0475 1.03394C40.8908 0.814598 40.8908 0.657929 40.9221 0.532593C40.7341 0.501259 40.5148 0.469925 40.3268 0.438591C40.2954 0.595261 40.2954 0.814598 40.3268 1.15927C40.0448 1.37861 39.7628 1.62928 39.4494 1.87995C39.4181 1.66061 39.2928 1.44128 39.3241 1.25327C39.3868 0.814598 39.3868 0.501259 39.2928 0.281921C37.9141 0.125252 36.4727 0.03125 35.0313 0.03125C32.65 0.03125 30.2999 0.281921 28.0439 0.720596C28.0439 0.783264 28.0752 0.877266 28.0439 1.0026C27.8245 0.939934 27.6679 0.877266 27.5739 0.783264C26.4145 1.03394 25.2551 1.34727 24.1271 1.72328C23.9705 1.87995 23.8765 1.91129 23.7511 1.84862C9.93286 6.54871 0 19.615 0 34.9999Z"
          fill="white"
        />
        <path
          d="M8.4283 35.3137C8.36564 30.5823 9.55633 25.9135 12.0004 21.7148L10.183 20.6494C6.36026 27.2922 5.32624 35.0004 7.33162 42.3952C9.30565 49.79 14.0684 55.9628 20.6799 59.8168L21.7452 57.9995C15.6978 54.5214 11.3424 48.9126 9.46232 42.1758C9.46232 42.2385 9.43099 42.2385 9.30565 42.3012C9.05498 41.9252 9.05498 42.0192 9.36832 41.8625C8.96098 40.2958 8.67898 38.7291 8.55364 37.1624C8.52231 37.1937 8.49097 37.2564 8.49097 37.2564C8.52231 38.0397 7.89563 38.1651 7.36295 38.5098C7.17495 38.1337 7.01828 37.8204 6.83027 37.4757C7.17495 37.3817 7.58229 37.3504 7.80162 37.1311C8.02096 36.9431 8.08363 36.5357 8.20897 36.2537C7.98963 36.003 7.80163 35.815 7.58229 35.5644C7.86429 35.345 8.0523 35.1884 8.2403 35.0004C8.27163 35.0944 8.30297 35.157 8.4283 35.3137Z"
          fill="white"
        />
        <path
          d="M35.2824 7.45746C35.0944 7.05012 34.875 6.61144 34.6557 6.2041C34.4677 6.61144 34.2483 7.05012 34.0603 7.45746C33.5903 7.52013 33.1517 7.61413 32.6816 7.73947C33.0576 8.02147 33.4023 8.30348 33.747 8.61682L33.5903 9.99551C33.9663 9.74484 34.311 9.5255 34.7184 9.30616C35.0944 9.49417 35.4704 9.74484 35.8464 9.96417L35.627 8.61682C35.9717 8.30348 36.3164 7.99014 36.6611 7.70813C36.2224 7.55146 35.7524 7.52013 35.2824 7.45746Z"
          fill="white"
        />
        <path
          d="M48.5983 56.8081L48.097 55.5234L47.4703 56.6828C47.0316 56.6828 46.593 56.6515 46.1543 56.6515L47.0003 57.7482C46.875 58.1868 46.7183 58.6255 46.5303 59.0328C46.969 58.9075 47.4077 58.7195 47.8463 58.5628C48.2223 58.8448 48.5983 59.0955 49.0057 59.3462C48.9743 58.8762 48.943 58.4062 48.9117 57.9675C49.2877 57.6855 49.6324 57.3721 49.977 57.0588C49.4757 56.9961 49.037 56.9021 48.5983 56.8081Z"
          fill="white"
        />
        <path
          d="M41.1424 61.1634C41.4244 61.508 41.7377 61.884 42.051 62.2287C42.145 61.7587 42.2391 61.32 42.3017 60.85L42.9284 60.568L43.5551 60.2547C43.2417 60.1293 42.9597 59.9727 42.6777 59.8473C42.6777 59.8787 42.6777 59.8787 42.6464 59.91C42.4271 60.2547 42.0824 59.8787 41.2364 59.252C40.7977 59.158 40.3903 59.0013 39.983 58.876L40.5157 60.1293C40.265 60.5053 40.0143 60.9127 39.7637 61.2887C40.2337 61.2574 40.6724 61.1947 41.1424 61.1634Z"
          fill="white"
        />
        <path
          d="M42.2703 59.1899L42.145 58.2812L41.2363 59.2213C41.7063 59.0959 42.051 59.0959 42.2703 59.1899Z"
          fill="white"
        />
        <path
          d="M34.0291 62.041C34.2171 62.4483 34.4364 62.887 34.6558 63.2943C34.8438 62.887 35.0631 62.4483 35.2511 62.041C35.7211 61.9783 36.1598 61.8843 36.6298 61.759C36.2538 61.477 35.9091 61.195 35.5645 60.8816L35.7211 59.5029C35.3451 59.7536 35.0004 59.9729 34.5931 60.1923C34.2171 60.0043 33.8411 59.7536 33.4651 59.5343L33.6844 60.8816C33.3397 61.195 32.9951 61.5083 32.6504 61.7903C33.1204 61.9156 33.5591 61.947 34.0291 62.041Z"
          fill="white"
        />
        <path
          d="M41.3929 9.99536C41.7062 10.3087 42.0196 10.622 42.3329 10.9354L42.4582 9.55669C42.8656 9.33735 43.2729 9.11801 43.6803 8.93001C43.2729 8.71067 42.8342 8.554 42.3956 8.366C42.3016 7.92732 42.2076 7.45731 42.1136 6.9873C41.8002 7.33198 41.5182 7.70799 41.2362 8.08399C40.7662 8.05266 40.2962 8.02132 39.8262 7.98999C40.1082 8.366 40.3902 8.71067 40.6409 9.11801L40.1395 10.4027L41.3929 9.99536Z"
          fill="white"
        />
        <path
          d="M27.2288 62.4481C27.5421 62.1034 27.8241 61.7274 28.1062 61.3514C28.5762 61.3827 29.0462 61.4141 29.5162 61.4454C29.2342 61.0694 28.9522 60.7247 28.7015 60.3174L29.2028 59.0327L27.9495 59.44C27.6361 59.1267 27.3228 58.8133 27.0095 58.5L26.8841 59.8787C26.4768 60.098 26.0695 60.3174 25.6621 60.5054C26.0695 60.7247 26.5081 60.8814 26.9468 61.0694V61.1007C27.0095 61.0067 27.0721 60.9127 27.1661 60.8187C27.4168 61.038 27.6361 61.226 27.9182 61.4454C27.5108 61.5394 27.2601 61.6334 27.0721 61.6647C27.1348 61.9781 27.1661 62.1974 27.2288 62.4481Z"
          fill="white"
        />
        <path
          d="M53.9577 52.4844L53.143 51.3877C53.049 51.8264 52.9237 52.2337 52.7984 52.6724C52.391 52.7977 51.921 52.8604 51.5137 52.9544L52.6104 53.8004C52.579 54.2391 52.5477 54.7091 52.485 55.1791C52.8924 54.9284 53.2684 54.6464 53.6444 54.3958C54.0831 54.5524 54.5217 54.7091 54.9604 54.8658C54.8351 54.4271 54.6784 53.9884 54.5217 53.5497C54.8037 53.1737 55.0857 52.7977 55.3364 52.4217C54.8664 52.4217 54.3964 52.453 53.9577 52.4844Z"
          fill="white"
        />
        <path
          d="M54.1446 13.6304C52.6719 12.3144 51.0739 11.155 49.3505 10.1523L48.2852 11.9697C54.4266 15.5104 58.8134 21.2446 60.6621 28.1067C60.8814 28.9214 61.0694 29.7674 61.1947 30.5821C61.3201 30.6134 61.4454 30.6761 61.5707 30.7701C61.5081 30.8954 61.4767 31.0834 61.3827 31.0834C61.3514 31.0834 61.3201 31.0834 61.2887 31.1147C61.3827 31.8041 61.4767 32.4934 61.5081 33.1514C61.5707 33.1828 61.6334 33.2454 61.6961 33.2768C61.6334 33.3394 61.5707 33.3708 61.5394 33.4021C61.6961 35.9402 61.4767 38.4782 60.9127 40.9223C61.2261 40.8283 61.5081 40.7343 61.8527 41.0476C61.9154 40.8283 61.9781 40.8909 61.4767 40.5462C61.1321 40.2956 61.1321 40.2956 61.5081 39.8256C61.7901 39.9196 61.8214 40.4522 62.2914 40.3269C62.3228 40.3269 62.4481 40.7029 62.4481 40.6716C62.3228 41.0476 61.9154 41.3923 62.4168 41.7683C62.1034 42.1443 61.8214 42.395 61.3514 42.4263C61.6647 42.9903 61.0694 43.1156 60.9441 43.4603C60.6621 43.4916 60.3801 43.4916 60.1294 43.523C59.722 44.7137 59.2207 45.873 58.6567 47.001C58.7507 47.0637 58.8447 47.1264 58.9387 47.189C58.6567 47.5024 58.5627 47.5964 58.312 47.6277C58.218 47.8157 58.124 48.0037 57.9987 48.1917L59.816 49.2571C63.6388 42.6143 64.6728 34.9061 62.6674 27.5113C61.2261 22.0906 58.2807 17.3278 54.2073 13.6617C54.0193 14.1004 54.1446 14.6644 53.5806 14.8524C52.9852 15.0404 52.6092 14.6331 52.2332 14.1318C52.8912 14.0064 53.2986 13.1604 54.1446 13.6304Z"
          fill="white"
        />
        <path
          d="M61.3518 42.5205C61.4458 41.4864 61.6025 41.2358 61.0071 41.3298C61.1638 41.7371 60.6311 42.2385 61.3518 42.5205Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2178_12364">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  checkEnabled: (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5" clipPath="url(#clip0_2178_12343)">
        <path
          d="M20.0547 12.5339C20.274 12.5653 20.4934 12.6279 20.744 12.6906L21.2454 13.9753L21.8721 12.816C22.3107 12.816 22.7494 12.8473 23.1881 12.8473L22.3421 11.7506C22.3734 11.6566 22.4047 11.5626 22.4361 11.4686C22.3421 11.4373 22.2481 11.4059 22.0601 11.3433C22.3421 11.0612 22.4674 10.9359 22.6241 10.9986C22.6867 10.8419 22.7494 10.6539 22.8121 10.4972C22.3734 10.6226 21.9347 10.8106 21.496 10.9672C21.2454 10.7792 20.9947 10.6226 20.744 10.4346C20.744 10.6539 20.7754 10.9046 20.6814 11.1866C20.556 10.9046 20.462 10.6852 20.368 10.5286C20.3994 10.8732 20.3994 11.2493 20.4307 11.5939C20.3994 11.6253 20.3367 11.6566 20.3054 11.7193C20.4307 11.7193 20.556 11.7193 20.7127 11.7193C20.7127 12.1266 20.556 12.3773 20.0547 12.5339Z"
          fill="#00C968"
        />
        <path
          d="M19.3965 12.4086C19.4592 12.4086 19.5218 12.44 19.5845 12.44C19.5845 12.3773 19.5845 12.3146 19.5845 12.252C19.4905 12.3146 19.4592 12.346 19.3965 12.4086Z"
          fill="#00C968"
        />
        <path
          d="M28.1686 8.30355C27.8866 7.95888 27.5732 7.6142 27.2599 7.26953C27.1659 7.73954 27.0719 8.17822 27.0092 8.64822L26.3825 8.93023L25.7559 9.24357C26.1945 9.43157 26.6019 9.61958 27.0092 9.83891L27.1972 11.1863L28.1059 10.2463C28.5446 10.3403 28.9519 10.4969 29.3593 10.6223L28.8266 9.3689C29.0773 8.9929 29.3279 8.58556 29.5786 8.20955C29.1086 8.20955 28.6386 8.27222 28.1686 8.30355Z"
          fill="#00C968"
        />
        <path
          d="M15.3846 16.9828L16.1992 18.0795C16.2932 17.6408 16.4186 17.2335 16.5439 16.7948C16.9513 16.6695 17.4213 16.6068 17.8286 16.5128L16.7319 15.6668C16.7633 15.2281 16.7946 14.7581 16.8573 14.2881C16.4499 14.5388 16.0739 14.8208 15.6979 15.0714C15.2592 14.9148 14.8205 14.7581 14.3819 14.6014C14.5072 15.0401 14.6639 15.4788 14.8205 15.9175C14.5385 16.2935 14.2565 16.6695 14.0059 17.0455C14.4759 17.0455 14.9145 17.0141 15.3846 16.9828Z"
          fill="#00C968"
        />
        <path
          d="M25.3802 50.2279C25.4116 49.9146 25.3802 49.8206 25.0669 49.6639C24.5969 49.4446 25.1296 49.1939 25.2549 48.9746C25.1296 48.8492 25.0669 48.7552 24.9102 48.5672C25.2549 48.4105 25.5682 48.2539 25.9129 48.0659C26.0696 48.5985 26.1949 49.0372 26.3203 49.5072C26.9783 49.5072 27.1976 50.0086 27.4796 50.6039C26.9156 50.4786 27.0409 50.3532 26.8216 51.0426L31.9604 54.0193C31.929 53.8 31.9917 53.612 32.211 53.5806C32.3364 53.5493 32.493 53.612 32.587 53.6746L35.1564 49.2252C35.0938 49.2252 35.0624 49.2566 34.9998 49.2566C34.9371 49.2566 34.8744 49.0999 34.8744 49.0686C34.9058 49.0059 34.9998 48.9432 35.1564 48.8492C35.1878 48.9432 35.2191 49.0059 35.2504 49.0686L36.3158 47.2512C36.1904 47.2199 36.0338 47.1885 35.7831 47.0945C36.0338 47.0005 36.2844 46.8752 36.5351 46.9065L37.3498 45.4652C37.2245 45.5278 37.0991 45.5905 36.9111 45.6218C36.5665 44.6818 36.8798 44.2118 37.9138 44.2118C37.8825 44.3685 37.8511 44.4938 37.8198 44.6505L43.1152 35.501C43.0526 35.5636 43.0212 35.595 42.9272 35.6576C42.9586 35.1876 42.9899 34.9056 43.3973 34.9996L46.8753 28.9835C46.844 28.9208 46.7813 28.7955 46.7186 28.6702C46.8127 28.6702 46.938 28.6702 47.032 28.7015L52.0141 20.0533L42.7706 14.7266L28.4196 39.6057L19.3015 34.3416L13.9434 43.6164L25.3802 50.2279Z"
          fill="#00C968"
        />
        <path
          d="M0 34.9999C0 35.1252 0 35.2193 0 35.3446C0.0626679 35.3133 0.125336 35.2819 0.250671 35.2819C0.282005 35.2819 0.407341 35.4386 0.376007 35.4386C0.282005 35.5639 0.219338 35.7206 0.0940018 35.7833C0.0626679 35.7833 0.0313339 35.8146 0 35.8146C0.0313339 37.6633 0.219338 39.4807 0.564011 41.2667C0.658013 41.204 0.72068 41.11 0.783348 40.9847C0.87735 40.7967 1.25336 40.734 1.53536 40.6087C1.62936 40.0447 1.03402 40.2013 0.814682 39.9507C0.689346 39.4807 0.595345 39.0107 0.407341 38.3213C1.06535 38.7913 1.37869 39.3867 1.9427 39.6687C2.09937 39.7313 2.25604 39.8253 2.41271 39.9193C2.38138 39.606 2.31871 39.324 2.28738 39.0107C1.97404 39.1047 1.69203 39.1673 1.41003 38.854C0.814682 38.1646 1.09669 37.5066 1.12802 37.2873C1.53536 37.1306 1.8487 37.068 2.09937 37.162C2.06804 36.8486 2.06804 36.5353 2.03671 36.1906C1.97404 36.1906 1.9427 36.1593 1.88004 36.1593C1.53536 36.0026 1.7547 35.8146 1.91137 35.5639C1.9427 35.5953 1.97404 35.6266 2.00537 35.6579C1.9427 33.0572 2.19338 30.4878 2.75739 28.0124C2.50671 27.7931 2.44405 27.6051 2.50671 27.3858C2.56938 27.1978 2.69472 27.1038 2.97672 27.1351C5.54611 16.7322 13.0976 7.86473 23.6571 4.01066C23.5631 3.91666 23.4691 3.82265 23.3438 3.72865C23.5945 3.66599 23.7511 3.60332 24.0018 3.54065C23.9705 3.66599 23.9705 3.79132 23.9705 3.91666C24.5658 3.69732 25.1925 3.50932 25.8192 3.32131C25.7252 3.03931 25.5998 2.72597 25.4745 2.34996C25.7878 2.44396 27.0412 2.60063 26.7278 3.07064C31.5533 1.81728 36.4414 1.69195 41.0475 2.5693C41.0161 2.53796 41.0161 2.53796 40.9848 2.50663C41.6115 2.34996 41.6741 2.31863 41.9561 2.7573C42.7081 2.91397 43.4288 3.10197 44.1495 3.32131C44.1808 3.28998 44.2122 3.22731 44.2748 3.16464C44.3062 3.25864 44.3375 3.32131 44.3689 3.38398C48.0663 4.48067 51.513 6.20403 54.615 8.49141C54.615 8.39741 54.615 8.27207 54.5837 8.05274C55.1791 8.33474 55.1164 8.14674 54.9597 8.71075C54.9284 8.71075 54.8971 8.67941 54.8657 8.67941C60.5372 12.9408 64.8926 19.0823 66.8666 26.4458C71.5667 43.9927 61.1012 62.1351 43.5542 66.8352C41.7995 67.3052 40.0448 67.6185 38.2587 67.8065C38.3841 67.9945 38.5721 68.1512 38.6034 68.3392C38.7287 69.1226 38.1334 69.1852 37.2874 69.5612C37.6321 68.9032 37.8827 68.3705 38.1647 67.8065C36.41 67.9632 34.624 67.9945 32.9006 67.9005C33.0573 68.0885 33.12 68.1825 32.9946 68.5899C32.9946 68.6212 32.744 68.6212 32.7126 68.5899C32.5246 68.2765 32.65 68.0572 32.744 67.9005C32.368 67.8692 31.9919 67.8379 31.6159 67.8065V67.8379C31.4906 67.8379 31.3966 67.8065 31.3339 67.7752C29.3912 67.5559 27.4485 67.1485 25.5998 66.5845C26.0072 67.0859 25.8818 67.2425 25.1298 67.6812C25.1611 67.4305 25.2865 67.1485 25.2238 67.0232C25.0985 66.8038 25.1298 66.6472 25.2238 66.4905C22.8111 65.7385 20.4924 64.7045 18.3304 63.4198C17.923 63.4198 17.829 63.4198 17.735 63.0751C17.4843 62.9184 17.2337 62.7618 17.0143 62.6051C16.9517 62.6678 16.9517 62.6364 16.795 62.5424C16.795 62.5111 16.8263 62.5111 16.8263 62.4798C10.3402 58.187 5.3581 51.6069 3.19606 43.5541C2.97672 42.7394 2.78872 41.8934 2.63205 41.0787C2.50671 41.0787 2.38138 41.0474 2.19338 41.016C1.8487 41.6114 1.50403 42.1754 0.814682 42.3321C1.00269 43.1781 1.22202 44.0241 1.44136 44.8701C1.50403 44.8074 1.62936 44.7448 1.7547 44.6508C1.6607 44.8074 1.59803 44.9954 1.50403 45.1521C2.38138 48.0975 3.66607 50.8862 5.2641 53.4556L5.29543 53.4243C5.51477 53.2363 5.0761 52.5469 5.82811 52.6722C5.89078 53.1423 5.89078 53.5496 5.48344 53.8629C5.51477 53.9256 5.54611 53.9883 5.60877 54.0509C5.67144 54.0196 5.79678 53.9883 6.01612 53.9256C5.92211 54.0196 5.85945 54.1449 5.76544 54.2703C11.8442 63.4824 22.1531 69.6866 33.9346 70.0312C33.9033 69.9999 33.872 69.9372 33.8406 69.9059C34.0287 69.9686 34.1853 69.9999 34.3107 70.0312C34.53 70.0312 34.7807 70.0312 35 70.0312C43.4915 70.0312 51.2623 67.0232 57.3098 61.9784C57.1218 61.9784 57.0591 61.9471 57.1844 61.5397C57.4351 61.7591 57.4664 61.7591 57.4664 61.8218C61.7905 58.2184 65.2059 53.5496 67.368 48.2855C67.2113 48.3795 67.0546 48.5048 66.8666 48.6302C66.8666 48.1915 66.9606 47.9095 67.3366 47.8155C67.368 47.8155 67.4306 47.8782 67.4933 47.9408C67.5873 47.7215 67.6813 47.4708 67.7753 47.2515C67.7126 47.2515 67.65 47.2515 67.5873 47.2515C67.6813 47.1261 67.8066 47.0008 67.932 46.8128C68.0573 46.4681 68.1826 46.1235 68.2766 45.7788C68.2453 45.7788 68.214 45.8101 68.1826 45.8414C68.308 45.4341 68.4333 45.0268 68.5586 44.5881C68.59 44.5881 68.6213 44.5881 68.6213 44.6194C68.684 44.3688 68.7466 44.1181 68.8406 43.8674C68.778 43.7734 68.8406 43.6481 68.9347 43.4287C69.5927 40.734 69.9687 37.914 69.9687 34.9999C69.9687 25.4431 66.1459 16.7636 59.9105 10.4654C59.8791 10.4654 59.8165 10.4968 59.7851 10.5281C59.4405 10.3714 59.3465 10.1208 59.3151 9.8701C56.6831 7.33205 53.6437 5.17001 50.3223 3.54065C50.291 3.57198 50.2283 3.60332 50.197 3.66599C50.197 3.60332 50.197 3.54065 50.197 3.50932C47.9409 2.34996 45.4655 1.50394 42.9275 0.9086C42.7708 1.19061 42.5515 1.44128 42.2068 1.62928C42.0188 1.75462 41.8308 1.91129 41.5801 1.62928C41.8621 1.47261 41.8621 0.971268 42.3635 1.06527C42.3948 1.06527 42.5201 0.939934 42.5515 0.845932C42.2695 0.783264 41.9875 0.720596 41.7055 0.657928C41.5488 0.75193 41.3295 0.877266 41.0475 1.03394C40.8908 0.814598 40.8908 0.657929 40.9221 0.532593C40.7341 0.501259 40.5148 0.469925 40.3268 0.438591C40.2954 0.595261 40.2954 0.814598 40.3268 1.15927C40.0448 1.37861 39.7628 1.62928 39.4494 1.87995C39.4181 1.66061 39.2928 1.44128 39.3241 1.25327C39.3868 0.814598 39.3868 0.501259 39.2928 0.281921C37.9141 0.125252 36.4727 0.03125 35.0313 0.03125C32.65 0.03125 30.2999 0.281921 28.0439 0.720596C28.0439 0.783264 28.0752 0.877266 28.0439 1.0026C27.8245 0.939934 27.6679 0.877266 27.5739 0.783264C26.4145 1.03394 25.2551 1.34727 24.1271 1.72328C23.9705 1.87995 23.8765 1.91129 23.7511 1.84862C9.93286 6.54871 0 19.615 0 34.9999Z"
          fill="#00C968"
        />
        <path
          d="M8.4283 35.3137C8.36564 30.5823 9.55633 25.9135 12.0004 21.7148L10.183 20.6494C6.36026 27.2922 5.32624 35.0004 7.33162 42.3952C9.30565 49.79 14.0684 55.9628 20.6799 59.8168L21.7452 57.9995C15.6978 54.5214 11.3424 48.9126 9.46232 42.1758C9.46232 42.2385 9.43099 42.2385 9.30565 42.3012C9.05498 41.9252 9.05498 42.0192 9.36832 41.8625C8.96098 40.2958 8.67898 38.7291 8.55364 37.1624C8.52231 37.1937 8.49097 37.2564 8.49097 37.2564C8.52231 38.0397 7.89563 38.1651 7.36295 38.5098C7.17495 38.1337 7.01828 37.8204 6.83027 37.4757C7.17495 37.3817 7.58229 37.3504 7.80162 37.1311C8.02096 36.9431 8.08363 36.5357 8.20897 36.2537C7.98963 36.003 7.80163 35.815 7.58229 35.5644C7.86429 35.345 8.0523 35.1884 8.2403 35.0004C8.27163 35.0944 8.30297 35.157 8.4283 35.3137Z"
          fill="#00C968"
        />
        <path
          d="M35.2824 7.45746C35.0944 7.05012 34.875 6.61144 34.6557 6.2041C34.4677 6.61144 34.2483 7.05012 34.0603 7.45746C33.5903 7.52013 33.1517 7.61413 32.6816 7.73947C33.0576 8.02147 33.4023 8.30348 33.747 8.61682L33.5903 9.99551C33.9663 9.74484 34.311 9.5255 34.7184 9.30616C35.0944 9.49417 35.4704 9.74484 35.8464 9.96417L35.627 8.61682C35.9717 8.30348 36.3164 7.99014 36.6611 7.70813C36.2224 7.55146 35.7524 7.52013 35.2824 7.45746Z"
          fill="#00C968"
        />
        <path
          d="M48.5983 56.8081L48.097 55.5234L47.4703 56.6828C47.0316 56.6828 46.593 56.6515 46.1543 56.6515L47.0003 57.7482C46.875 58.1868 46.7183 58.6255 46.5303 59.0328C46.969 58.9075 47.4077 58.7195 47.8463 58.5628C48.2223 58.8448 48.5983 59.0955 49.0057 59.3462C48.9743 58.8762 48.943 58.4062 48.9117 57.9675C49.2877 57.6855 49.6324 57.3721 49.977 57.0588C49.4757 56.9961 49.037 56.9021 48.5983 56.8081Z"
          fill="#00C968"
        />
        <path
          d="M41.1424 61.1634C41.4244 61.508 41.7377 61.884 42.051 62.2287C42.145 61.7587 42.2391 61.32 42.3017 60.85L42.9284 60.568L43.5551 60.2547C43.2417 60.1293 42.9597 59.9727 42.6777 59.8473C42.6777 59.8787 42.6777 59.8787 42.6464 59.91C42.4271 60.2547 42.0824 59.8787 41.2364 59.252C40.7977 59.158 40.3903 59.0013 39.983 58.876L40.5157 60.1293C40.265 60.5053 40.0143 60.9127 39.7637 61.2887C40.2337 61.2574 40.6724 61.1947 41.1424 61.1634Z"
          fill="#00C968"
        />
        <path
          d="M42.2703 59.1899L42.145 58.2812L41.2363 59.2213C41.7063 59.0959 42.051 59.0959 42.2703 59.1899Z"
          fill="#00C968"
        />
        <path
          d="M34.0291 62.041C34.2171 62.4483 34.4364 62.887 34.6558 63.2943C34.8438 62.887 35.0631 62.4483 35.2511 62.041C35.7211 61.9783 36.1598 61.8843 36.6298 61.759C36.2538 61.477 35.9091 61.195 35.5645 60.8816L35.7211 59.5029C35.3451 59.7536 35.0004 59.9729 34.5931 60.1923C34.2171 60.0043 33.8411 59.7536 33.4651 59.5343L33.6844 60.8816C33.3397 61.195 32.9951 61.5083 32.6504 61.7903C33.1204 61.9156 33.5591 61.947 34.0291 62.041Z"
          fill="#00C968"
        />
        <path
          d="M41.3929 9.99536C41.7062 10.3087 42.0196 10.622 42.3329 10.9354L42.4582 9.55669C42.8656 9.33735 43.2729 9.11801 43.6803 8.93001C43.2729 8.71067 42.8342 8.554 42.3956 8.366C42.3016 7.92732 42.2076 7.45731 42.1136 6.9873C41.8002 7.33198 41.5182 7.70799 41.2362 8.08399C40.7662 8.05266 40.2962 8.02132 39.8262 7.98999C40.1082 8.366 40.3902 8.71067 40.6409 9.11801L40.1395 10.4027L41.3929 9.99536Z"
          fill="#00C968"
        />
        <path
          d="M27.2288 62.4481C27.5421 62.1034 27.8241 61.7274 28.1062 61.3514C28.5762 61.3827 29.0462 61.4141 29.5162 61.4454C29.2342 61.0694 28.9522 60.7247 28.7015 60.3174L29.2028 59.0327L27.9495 59.44C27.6361 59.1267 27.3228 58.8133 27.0095 58.5L26.8841 59.8787C26.4768 60.098 26.0695 60.3174 25.6621 60.5054C26.0695 60.7247 26.5081 60.8814 26.9468 61.0694V61.1007C27.0095 61.0067 27.0721 60.9127 27.1661 60.8187C27.4168 61.038 27.6361 61.226 27.9182 61.4454C27.5108 61.5394 27.2601 61.6334 27.0721 61.6647C27.1348 61.9781 27.1661 62.1974 27.2288 62.4481Z"
          fill="#00C968"
        />
        <path
          d="M53.9577 52.4844L53.143 51.3877C53.049 51.8264 52.9237 52.2337 52.7984 52.6724C52.391 52.7977 51.921 52.8604 51.5137 52.9544L52.6104 53.8004C52.579 54.2391 52.5477 54.7091 52.485 55.1791C52.8924 54.9284 53.2684 54.6464 53.6444 54.3958C54.0831 54.5524 54.5217 54.7091 54.9604 54.8658C54.8351 54.4271 54.6784 53.9884 54.5217 53.5497C54.8037 53.1737 55.0857 52.7977 55.3364 52.4217C54.8664 52.4217 54.3964 52.453 53.9577 52.4844Z"
          fill="#00C968"
        />
        <path
          d="M54.1446 13.6304C52.6719 12.3144 51.0739 11.155 49.3505 10.1523L48.2852 11.9697C54.4266 15.5104 58.8134 21.2446 60.6621 28.1067C60.8814 28.9214 61.0694 29.7674 61.1947 30.5821C61.3201 30.6134 61.4454 30.6761 61.5707 30.7701C61.5081 30.8954 61.4767 31.0834 61.3827 31.0834C61.3514 31.0834 61.3201 31.0834 61.2887 31.1147C61.3827 31.8041 61.4767 32.4934 61.5081 33.1514C61.5707 33.1828 61.6334 33.2454 61.6961 33.2768C61.6334 33.3394 61.5707 33.3708 61.5394 33.4021C61.6961 35.9402 61.4767 38.4782 60.9127 40.9223C61.2261 40.8283 61.5081 40.7343 61.8527 41.0476C61.9154 40.8283 61.9781 40.8909 61.4767 40.5462C61.1321 40.2956 61.1321 40.2956 61.5081 39.8256C61.7901 39.9196 61.8214 40.4522 62.2914 40.3269C62.3228 40.3269 62.4481 40.7029 62.4481 40.6716C62.3228 41.0476 61.9154 41.3923 62.4168 41.7683C62.1034 42.1443 61.8214 42.395 61.3514 42.4263C61.6647 42.9903 61.0694 43.1156 60.9441 43.4603C60.6621 43.4916 60.3801 43.4916 60.1294 43.523C59.722 44.7137 59.2207 45.873 58.6567 47.001C58.7507 47.0637 58.8447 47.1264 58.9387 47.189C58.6567 47.5024 58.5627 47.5964 58.312 47.6277C58.218 47.8157 58.124 48.0037 57.9987 48.1917L59.816 49.2571C63.6388 42.6143 64.6728 34.9061 62.6674 27.5113C61.2261 22.0906 58.2807 17.3278 54.2073 13.6617C54.0193 14.1004 54.1446 14.6644 53.5806 14.8524C52.9852 15.0404 52.6092 14.6331 52.2332 14.1318C52.8912 14.0064 53.2986 13.1604 54.1446 13.6304Z"
          fill="#00C968"
        />
        <path
          d="M61.3518 42.5205C61.4458 41.4864 61.6025 41.2358 61.0071 41.3298C61.1638 41.7371 60.6311 42.2385 61.3518 42.5205Z"
          fill="#00C968"
        />
      </g>
      <defs>
        <clipPath id="clip0_2178_12343">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  closeSigner: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6654 4.2735L11.7254 3.3335L7.9987 7.06016L4.27203 3.3335L3.33203 4.2735L7.0587 8.00016L3.33203 11.7268L4.27203 12.6668L7.9987 8.94016L11.7254 12.6668L12.6654 11.7268L8.9387 8.00016L12.6654 4.2735Z"
        fill="#222D4B"
      />
    </svg>
  ),
  iconPdf: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM16 12V9C16 8.45 15.55 8 15 8H13V13H15C15.55 13 16 12.55 16 12ZM14 9H15V12H14V9ZM18 11H19V10H18V9H19V8H17V13H18V11ZM10 11H11C11.55 11 12 10.55 12 10V9C12 8.45 11.55 8 11 8H9V13H10V11ZM10 9H11V10H10V9Z"
        fill="#222D4B"
      />
    </svg>
  ),
  trashIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
        fill="#E50500"
      />
    </svg>
  ),
  uploadProfile: (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 24H22.5V15H28.5L18 4.5L7.5 15H13.5V24ZM18 8.745L21.255 12H19.5V21H16.5V12H14.745L18 8.745ZM7.5 27H28.5V30H7.5V27Z"
        fill="#00C968"
      />
    </svg>
  ),
  noticePartner: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4043 7H13.4043V9H11.4043V7ZM11.4043 11H13.4043V17H11.4043V11ZM12.4043 2C6.8843 2 2.4043 6.48 2.4043 12C2.4043 17.52 6.8843 22 12.4043 22C17.9243 22 22.4043 17.52 22.4043 12C22.4043 6.48 17.9243 2 12.4043 2ZM12.4043 20C7.9943 20 4.4043 16.41 4.4043 12C4.4043 7.59 7.9943 4 12.4043 4C16.8143 4 20.4043 7.59 20.4043 12C20.4043 16.41 16.8143 20 12.4043 20Z"
        fill="#0D99FF"
      />
    </svg>
  ),
}
